// Copyright (c) 2016 Deere & Company

export default Object.freeze({
    A_LAYOUT_WITH_THAT_NAME_ALREADY_EXISTS: `Une mise en page portant ce nom existe déjà`,
    ACCEPT: `Accepter`,
    ACCEPT_ALL: `Tout accepter`,
    ACCEPT_REJECT_TRANSFER_PENDING: `Approbation en attente`,
    ACCEPTED: `Accepté`,
    ACCOUNT: `Compte`,
    ACCOUNT_ADDRESS: `Adresse du concessionnaire`,
    ACCOUNT_COUNTRY: `Pays de compte`,
    ACCOUNT_END: `Fin de compte`,
    ACCOUNT_NAME: `Nom de compte`,
    ACCOUNT_NUMBER: `Numéro de compte`,
    ACCOUNT_NUMBER_REQUIRED: `Numéro de compte nécessaire`,
    ACCOUNTS: `Comptes`,
    ACCUMULATED_DAYS_ON_RENT: `Jours accumulés en location`,
    ACCUMULATED_DAYS_RENTED: `Jours accumulés de location`,
    ACTIONS: `Actions`,
    ACTIVE_WARRANTY: `Garantie active`,
    ACTIVE_WARRANTY_CLICK_FOR_DETAIL: `Garantie active (cliquer pour plus d’informations)`,
    ACTIVE_WARRANTY_Y_N: `Garantie active (O/N)`,
    ACTUAL_AMOUNT_OF_USE: `Quantité réelle d'utilisation`,
    ACTUAL_AUDIT: `Audit actuel`,
    ACTUAL_AUDIT_DATE: `Date atuelle d'audit`,
    ACTUAL_COURIER_NAME: `Nom réel du transporteur`,
    ACTUAL_H: `Heures réelles`,
    ACTUAL_HOURS: `Heures réelles`,
    ACTUAL_PC:`Balles réelles`,
    ADD_CLAIM: `Ajouter une demande de garantie`,
    ADD_CLAIMS: `Ajouter des demandes de garantie`,
    ADD_COMPONENT: `Ajouter un composant`,
    ADD_OPTION: `Ajouter une option`,
    ADD_REP: `Réparation additionelle`,
    ADD_TO_AUDIT: `Ajouter à l’audit`,
    ADDITIONAL: `Supplémentaire`,
    ADDITIONAL_COMMENTS: `Commentaires additionnels`,
    ADDITIONAL_REPAIR: `Réparation additionelle`,
    ADDITIVE: `Additif`,
    ADDRESS: `Adresse`,
    ADDRESS_LINE1: `Ligne d'adresse 1`,
    ADDRESS_LINE1_REQUIRED: `Ligne d'adresse 1 requise`,
    ADDRESS_LINE2: `Ligne d'adresse 2`,
    ADJ_CLM: `Ajuster la demande de garantie`,
    ADJUST_CLAIM: `Ajuster la demande de garantie`,
    ADJUSTED_HOURS: `Heures ajustées`,
    ADJUSTED_QUANTITY: `Quantité réglée`,
    ADJUSTMENT_TYPE: `Type de réglage`,
    ADVANCED_CLAIM_SUMMARY: `Avancée Sommaire de la demande de garantie`,
    AFTER_DELIVERY_INSPECTION: `INSPECTION APRÈS LIVRAISON`,
    AGENCY_NAME: `Nom de l'agence`,
    ALL: `Tout`,
    ALL_ACCOUNTS: `Tous les comptes`,
    ALL_CLAIMS: `Toutes les demandes de garantie`,
    ALL_CLAIMS_ARE_SUBJECT_TO_REVIEW: `Toutes les demandes sont sujettes à examen (voir JD WAM 110,08 pour plus d'informations)`,
    ALL_CLAIMS_TAB: `Toutes les demandes de garantie ({count, number})`,
    ALL_PART_REQUESTS: `Toutes les demandes de retour de pièces`,
    ALL_PART_REQUESTS_WITH_COUNT: `Toutes les demandes de retour de pièces ({count})`,
    ALL_PARTS_RETURNED: `Toutes les pièces retournées`,
    AMOUNT: `Montant`,
    AMOUNT_1: `Montant 1`,
    AMOUNT_2: `Montant 2`,
    AMOUNT_3: `Montant 3`,
    AMOUNT_OF_USE: `Nombre d'usage`,
    AMOUNT_OF_USE_ACCEPETD: `Quantité d'utilisation acceptée`,
    AMOUNT_OF_USE_CREATED_SUCCESSFULLY: `Quantité d'utilisation correctement créée`,
    AMOUNT_OF_USE_HISTORY_WITH_COUNT: `Historique du nombre d'usage ({count})`,
    AMOUNT_OF_USE_IS_REQUIRED: `Nombre d'usage est obligatoire`,
    AMOUNT_OF_USE_REJECTED: `Quantité d'utilisation rejetée`,
    AMOUNT_OF_USE_REQUESTS_STATUS: `État des demandes de quantité d'utilisation`,
    AMOUNT_OF_USE_REQUESTS_WITH_COUNT: `Nombre de demandes d'utilisation ({count})`,
    AMOUNT_OF_USE_REQUIRED: `Nombre d'usage est obligatoire`,
    AMOUNT_OF_USE_UNITS_REQUIRED: `Les unités du nombre d'usage est obligatoire`,
    AMOUNT_RECORDED: `Unité enregistrée`,
    AMOUNT_TO_BE_DEBITED: `Montant à débiter`,
    APLYPIP: `Appliquer le programme (PIP)`,
    APPLICATION: `Application`,
    APPLICATION_IS_REQUIRED: `Application est obligatoire`,
    APPLY: `Appliquer`,
    APPLY_TRAVEL: `Appliquer le déplacement `,
    APPROVAL_DEALER_COMMENTS: `Commentaires d'approbabtion du concessionnaire`,
    APPROVAL_DETAILS: `Détails d’approbation`,
    APPROVAL_LEVELS: `Niveaux d’approbation`,
    APPROVAL_REMARKS: `Remarques d'approbation`,
    APPROVAL_STATUS: `État d'approbation`,
    APPROVE: `Approuver`,
    APPROVE_AMOUNT_OF_USE: `Approuver le niveau d'utilisation`,
    APPROVE_LABOR_RATE: `Approuver le taux de main-d’œuvre`,
    APPROVE_MACHINE_STATUS_UPDATE: `Approuver la mise à jour du statut de la machine`,
    APPROVE_PIP_CODE_REQUEST: `Approuver la demande du code du programme (PIP)`,
    APPROVE_SPECIAL_ALLOWANCE_CLAIM: `Approuver la demande de garantie d’allocation commerciale`,
    APPROVED: `Approuvé(e)`,
    APPROVED_CORE_VALUE: `Valeur du carcasse approuvée`,
    APPROVED_DATE_CANNOT_BE_BEFORE_SETUP_DATE: `Date d’approbation ne peut pas être antérieure à la date de configuration`,
    APPROVED_DIAGNOSTIC_AMOUNT: `Montant de diagnostic approuvée`,
    APPROVED_DIAGNOSTIC_HOURS: `Heures de diagnostic approuvées`,
    APPROVED_IS_REQUIRED: `Le champ Approuvé est obligatoire`,
    APPROVED_LABOR_ADDITIVE: `Additif de main d'oeuvre approuvée`,
    APPROVED_LABOR_AMOUNT: `Main d'oeuvre approuvée`,
    APPROVED_LABOR_HOURS: `Heures de travail approuvées`,
    APPROVED_LABOR_TOTAL: `Total main d'oeuvre approuvée`,
    APPROVED_ON_SHELF_COST: `Coût local approuvé`,
    APPROVED_OTHER_CREDITS: `Autres crédits approuvés`,
    APPROVED_PARTS: `Pièces approuvées`,
    APPROVED_PARTS_ADDITIVE: `Additif de Pièces Approuvé`,
    APPROVED_PARTS_TOTAL: `Total de la partie approuvée`,
    APPROVED_REJECTED: `Approuvé(e)/Rejeté(e)`,
    APPROVED_REPAIR_AMOUNT: `Montant de réparation approuvé`,
    APPROVED_REPAIR_HOURS: `Heures de réparation approuvées`,
    APPROVED_TAXES_TOTAL: `Total des taxes approuvées`,
    APPROVED_TRAVEL_TOTAL: `Total de déplacement-approuvé`,
    APPROVER: `Approbateur`,
    ASCENDING: `Croissant`,
    ATTACHMENTS: `Pièces jointes`,
    AUDIT_NUMBER: `Numéro d’audit`,
    AUDIT_PLANNED: `Audit planifié`,
    AUDIT_REQUIREMENT: `Exigence de l’audit`,
    AUDIT_RESULTS: `Résultats de l'audit`,
    AUDIT_STATUS: `État de l’audit`,
    AUDIT_SUBMITTED_SUCCESSFULLY: `Audit soumis avec succès`,
    AUDIT_SUMMARY: `Résumé de l’audit`,
    AUDIT_TYPE: `Type d’audit`,
    AUDITS: `Audits`,
    AUDITS_DUE_WITH_COUNT: `{countToDisplay} audits dus`,
    AUDITS_DUE_WITHIN_30_DAYS: `{countToDisplay} {count, plural, one {audit} other {audits}} dus dans les 30 jours`,
    AUDITS_PAST_DUE_WITH_COUNT: `{countToDisplay} {count, plural, one {audit} other {audits}} en retard`,
    AUTHORIZATION_NUMBER: `Nº d'autorization`,
    AUTO_SUBMIT_FROM_DEALER_BUSINESS_SYSTEM: `Soumission automatique à partir du système de gestion du concessionnaire`,
    AVAILABLE: `Disponible`,
    AVAILABLE_COLUMNS: `Colonnes Disponibles`,
    AVERAGE_DIAGNOSTICS_HOURS: `Temps moyen de diagnostic`,
    AVERAGE_LUG_HEIGHT: `Hauteur moyen des crampons`,
    AVERAGE_LUG_HEIGHT_IS_REQUIRED: `Hauteur moyenne de crampon est obligatoire.`,
    AVERAGE_REPAIR_HOURS: `Temps moyen de réparation`,
    AVERAGE_REPLACEMENT_HOURS: `Temps moyen de remplacement`,
    AVERAGE_TECH_PAY_RATE: `Tarif moyen de rémunération du technicien`,
    BACK: `Retour`,
    BACK_TO_AUDIT: `Retour sur l’audit`,
    BASE_MACHINE: `Machine de base`,
    BASE_MACHINE_IMPLEMENTS: `Équipements de machine de base`,
    BASE_MACHINE_PIN: `NIP de machine de base`,
    BASIC_WARRANTY_ENDS: `Garantie de base expirée`,
    BASIC_WARRANTY_ESTIMATOR: `Estimateur de garantie de base`,
    BASIC_WARRANTY_STARTS: `Garantie de base commence`,
    BASIS_FOR_SETTLEMENT: `Base de règlement`,
    BASIS_FOR_SETTLEMENT_AUDIT_COMMENTS: `Base de règlement / Commentaires d’audit`,
    BASIS_FOR_SETTLEMENT_IS_REQUIRED: `Base de règlement est obligatoire.`,
    BATTERY: `Batterie`,
    BEGIN_DATE: `Date du début`,
    BRANCH: `Branche`,
    BUILT: `Conçu(e)`,
    BUSINESS_END: `Business End`,
    CAN_THE_MACHINE_BE_PUT_BACK_INTO_SERVICE:`La machine peut-elle être remise en service ?`,
    CANCEL: `Annuler`,
    CERTIFIED_LETTER_SENT: `Lettre recommandée envoyée`,
    CGST: `CGST`,
    CHANGE_RESPONSIBLE_DEALER: `Changer le concessionnaire résponsable`,
    CHANGE_STATUS: `Changer le status`,
    CHANGE_STATUS_FOR: `Changer le statut pour {pin}`,
    CHANGED: `Modifié`,
    CHANGED_BY: `Changé(e) par`,
    CHANGED_ON: `Changé(e) le`,
    CHINESE: `Chinois`,
    CITY: `Ville`,
    CITY_REQUIRED: `Ville requise`,
    CLAIM: `Demande de garantie`,
    CLAIM_COUNT_WITH_PARENTHESIS: `({countToDisplay} {count, plural, one {Claim} other {Claims}})`,
    CLAIM_DEBIT: `Débit de la demande de garantie`,
    CLAIM_DETAILS: `Détails de la demande de garantie`,
    CLAIM_DRAFT: `ÉBAUCHE`,
    CLAIM_HISTORY: `24 mois de demandes de garantie antérieures`,
    CLAIM_HISTORY_WITH_COUNT: `24 mois de demandes de garantie antérieures ({count})`,
    CLAIM_NUMBER: `Numéro de demande de garantie`,
    CLAIM_RECOVER_PERCENTAGE: `({percentage}%)`,
    CLAIM_SEARCH: `Recherche de la demande`,
    CLAIM_STATUS: `Statut de la demande de garantie`,
    CLAIM_TYPE: `Type de démande de garantie`,
    CLAIM_TYPES: `Types de demande de garantie`,
    CLAIM_UPDATED_SUCCESSFULLY: `Demande de garantie mise à jour avec succès`,
    CLAIM_VALUE: `Valeur de la demande de garantie`,
    CLAIM_VALUE_DETAILS: `Détails de la valeur de demande de garantie`,
    CLAIM_WITH_NUMBER: `Demande de garantie {claimNumber}`,
    CLAIMS: `Demandes de garantie`,
    CLAIMS_IN_PROGRESS: `Demandes de garantie en cours`,
    CLAIMS_IN_PROGRESS_WITH_COUNT: `Demandes en cours ({count})`,
    CLAIMS_OVERVIEW: `Aperçu des demandes de garantie`,
    CLAIMS_OVERVIEW_TAB: `Aperçu des demandes de garantie ({count})`,
    CLAIMS_WITH_COUNT: `{count} demandes de garantie`,
    CLICK_FOR_DETAILS: `(Cliquez ici pour les détails)`,
    CLICK_TO_VIEW_ALL: `Cliquer pour tout afficher`,
    CLOSE: `Fermer`,
    CLOSED_PART_REQUESTS: `Demandes de pièces fermées`,
    CLOSING: `Fermeture`,
    CLOSING_ACCOUNT: `Compte de clôture`,
    CLOSING_ACCOUNT_WITH_COUNT: `Clôture du compte ({count})`,
    CODE: `Code`,
    COLLAPSE_ALL: `Réduire tout`,
    COMMENT: `Commentaire`,
    COMMENTS: `Commentaires`,
    COMMENTS_IS_REQUIRED: `Commentaires obligatoires`,
    COMMENTS_TO_DEALER: `Comments au concessionnaire`,
    COMMON_LABOR_TYPES_WARNING: `Tous les types de main-d'oeuvre ne sont pas disponibles pour les comptes sélectionnés`,
    COMPANY: `Entreprise`,
    COMPANY_CONTRIBUTION: `Contribution de la Compagnie`,
    COMPANY_CONTRIBUTION_IS_REQUIRED: `Contribution de la compagnie est obligatoire`,
    COMPLAINT_CAUSE: `Quels étaient les diagnostics de la plainte?`,
    COMPLAINT_CAUSE_IS_REQUIRED: `Le diagnostic de la plainte est requis`,
    COMPLAINT_CORRECTION: `Comment la plainte a-t-elle été remise en état?`,
    COMPLAINT_CORRECTION_IS_REQUIRED: `La remise en état de la plainte est requise`,
    COMPLETE: `Terminé`,
    COMPLETED: `Terminé(e)`,
    COMPLETED_BY: `Terminé(e) par`,
    COMPLETED_DATE: `Date d'achèvement`,
    COMPLETED_IN_LAST_24_MONTHS: `Terminé dans les 24 derniers mois`,
    COMPLETION_STATUS: `État d’achèvement`,
    COMPONENT: `Composant`,
    COMPONENT_CODE: `Code du Composant`,
    COMPONENT_CREATED_SUCCESSFULLY: `Consosant créé avec succès`,
    COMPONENT_DELETED_SUCCESSFULLY: `Composant suprimé avec succes`,
    COMPONENT_SERIAL_NUMBER: `Numéro de série du composant`,
    COMPONENT_SUCCESSFULLY_UPDATED: `Mise à jour réussie du composant`,
    COMPONENTS: `Composants`,
    CONFIRM: `Confirmer`,
    CONFIRM_ADDITIONAL_REPAIR: `Êtes-vous sûr de vouloir ajouter une réparation supplémentaire?`,
    CONFIRM_ADJUST_CLAIM: `Êtes-vous sûr de vouloir modifier cette demande de garantie?`,
    CONFIRM_CLOSING_ACCOUNT: `Voulez-vous vraiment accepter ce transfert?`,
    CONFIRM_COPY_CLAIM: `Êtes-vous sûr de vouloir copier cette demande de garantie?`,
    CONFIRM_DELETE_ATTACHMENT: `Êtes-vous sûr de vouloir supprimer le fichier joint?`,
    CONFIRM_DELETE_CLAIM: `Êtes-vous sûr de vouloir supprimer cette demande de garantie?`,
    CONFIRM_DELETE_MACHINE_STATUS_UPDATE: `Voulez-vous vraiment supprimer cette demande d'état de la machine?`,
    CONFIRM_DELETE_REGISTRATION: `Êtes-vous sûr de vouloir supprimer cet enregistrement?`,
    CONFIRM_EDIT_CLAIM: `Êtes-vous sûr de vouloir modifier cette revendication?`,
    CONFIRM_RECONCILE_CLAIM: `Êtes-vous sûr de vouloir résoudre cette réclamation?`,
    CONFIRM_RESEND_XML: `Voulez-vous vraiment renvoyer XML ? Veuillez prévoir de 24 à 48 heures pour qu'il soit visible.`,
    CONFIRM_SKIP_AUDIT: `Êtes-vous sûr de vouloir ignorer cet audit?`,
    CONFIRM_UNDO_REGISTRATION: `Voulez-vous vraiment annuler cet enregistrement?`,
    CONFIRM_UNRECONCILE_CLAIM: `Voulez-vous vraiment annuler le rapprochement de cette demande?`,
    CONNECTED_MACHINE: `Machine connectée`,
    CONTACTED: `Contacté(e)`,
    CONTAINS: `Contient`,
    CONTRACT_NUMBER: `Numéro du contrat`,
    CONTRACT_PURCHASED: `Contrat acheté`,
    CONTRACT_TYPE: `Type de contrat`,
    COPY_CLAIM: `Copier la demande de garantie`,
    CORE: `Carcasse`,
    CORE_VALUE: `Valeur de la carcasse`,
    COUNTRY: `Pays`,
    COUNTRY_REQUIRED: `Pays requis`,
    COURIER_ACCOUNT_NUMBER: `Numéro de compte de transporteur`,
    COURIER_NAME: `Nom du transporteur`,
    COVERAGE_DECISION: `Décision de couverture`,
    COVERAGE_TYPE: `Type de couverture`,
    CRDMEM: `Numéro de crédit`,
    CREATE: `Créer`,
    CREATE_CLAIM: `Créer une demande de garantie`,
    CREATE_LAYOUT: `Créer Mise en Page`,
    CREATE_NON_TRACKED_PIN_HELP_TEXT: `Avant de pouvoir soumettre une demande pour ce produit, vous devez nous fournir plus d’informations sur ce produit`,
    CREATE_PIP_CLAIM: `Créer une demande de garantie du programme (PIP)`,
    CREATE_PIP_CLAIMS: `Créer des demandes de garantie du programme (PIP)`,
    CREATE_PRODUCT_RECORD: `Créer un record du produit`,
    CREATE_REQUEST: `Créer une demande`,
    CREATE_TRANSFER_PENDING: `Transfert en attente`,
    CREATE_TRANSFER_SERVICE_UNAVAILABLE: `Créer Service de transfert non disponible`,
    CREATED: `Créé(e)`,
    CREATED_BY: `Créé(e) par`,
    CREATED_DATE: `Date de création`,
    CREATED_DATE_FROM: `Depuis la date de création`,
    CREATED_DATE_TO: `À la date de création`,
    CREATED_ON: `Créé(e) le`,
    CREATION_DATE: `Date de création`,
    CREDIT_MEMO: `Note de crédit`,
    CREDIT_MEMO_DATE: `Date de note de crédit`,
    CREDIT_MEMO_ISSUE_DATE: `Note de crédit émise`,
    CREDIT_MEMO_NUMBER: `Numéro de note de crédit`,
    CREDIT_MEMO_PROCESS_DATE: `Note de crédit traitée`,
    CREDIT_MEMO_SELECTED: `Note de crédit sélectionnée`,
    CREDIT_MEMOS: `Notes de crédit`,
    CRITERIA: `Critère`,
    CRT: `Créer`,
    CSV_SEPARATOR: `Séparateur CSV`,
    CURRENCY: `Devise`,
    CURRENT: `Actuellement`,
    CURRENT_ACCOUNT: `Compte actuel`,
    CURRENT_AMOUNT_OF_USE: `Nombre d'usage actuel`,
    CURRENT_CUSTOMER: `Client actuel`,
    CURRENT_DEALER: `Concessionnaire actuel`,
    CURRENT_DEALER_DISTANCE: `Distance actuelle du concessionnaire`,
    CURRENT_DEALER_LAST_SERVICE_DATE: `Date du dernier service du concessionnaire actuel`,
    CURRENT_DEALER_LOCATION: `Localisation actuel du concessionnaire`,
    CURRENT_HOURS: `Heures actuelles`,
    CURRENT_QUANTITY: `Quantité actuelle`,
    CURRENT_RESPONSIBLE_DEALER: `Vendeur responsable actuel`,
    CURRENT_VALUES: `Valeurs actuelles`,
    CURRENTLY_ON_RENT: `En location`,
    CUSTOM_RANGE: `Intervalle personnalisé`,
    CUSTOM_VALUES: `Valeurs personnalisées`,
    CUSTOMER: `Client(e)`,
    CUSTOMER_CONTRIBUTION: `Contribution du client`,
    CUSTOMER_CONTRIBUTION_IS_REQUIRED: `Contribution du client est obligatoire`,
    CUSTOMER_CREATED_SUCCESSFULLY: `Client créé avec succès`,
    CUSTOMER_DETAILS: `Détails du client`,
    CUSTOMER_DETAILS_UPDATED_SUCCESSFULLY: `Détails du client mis à jour avec succès`,
    CUSTOMER_INFORMATION: `Informations client`,
    CUSTOMER_INFORMATION_IS_REQUIRED: `Les informations client sont obligatoires.`,
    CUSTOMER_INVALID: `Client ne peut être créé ou trouvé, rechercher un client`,
    CUSTOMER_NAME: `Nom du client`,
    CUSTOMER_NAME_IS_REQUIRED: `Les informations client sont obligatoires.`,
    CUSTOMER_NOT_FOUND: `Client introuvable`,
    CUSTOMER_PROFILE: `Profil du client`,
    CUSTOMER_REQUIRED: `Client obligatoire`,
    CUSTOMER_RESOLUTION: `Résolution du client`,
    CUSTOMER_RESOLUTION_IS_REQUIRED: `Résolution du client est obligatoire`,
    CUSTOMER_SEARCH: `Recherche du client`,
    CUSTOMER_UPDATED_SUCCESSFULLY: `Mise à jour du client réussie`,
    DAMAGED_MACHINES_HELP_TEXT:`Dans le cas d’une machine endommagée, la garantie sera automatiquement suspendue jusqu’à examen du présent formulaire par le TCSM et approbation du rétablissement de la garantie. Les machines endommagées peuvent faire l’objet uniquement de ces PIP : obligatoire et Sécurité obligatoire .`,
    DATE: `Date`,
    DATE_FORMAT: `Format de date`,
    DATE_ISSUED: `Date émise`,
    DATE_OF_CERTIFIED_LETTER: `Date de la lettre certifiée`,
    DATE_OF_EVENT_CAUSING_DAMAGE:`Date de l’endommagement`,
    DATE_OF_LAST_PERSONAL_CONTACT: `Date du dernier contact personel`,
    DATE_RECALLED_PART_WAS_SHIPPED_SENT: `Date d'expédition de Demande de Retour de Pièce`,
    DATE_REFUSED: `Date de refus`,
    DATE_SUBMITTED: `Date de soumission`,
    DAYS_FROM_REGISTRATION: `Jours depuis l’enregistrement`,
    DAYS_LEFT: `Jours restants`,
    DAYS_LEFT_WITH_COUNT: `{daysToDisplay} {days, plural, one {jour restant} other {jours restants}}`,
    DAYS_ON_RENT: `Jours loués`,
    DAYS_REMAINING: `Jours restants`,
    DAYS_REMAINING_WITH_COUNT: `{daysToDisplay} {days, plural, one {jour restant} other {jours restants}}`,
    DAYS_SINCE_RECOMMENDATION: `{daysToDisplay} {days, plural, one {jour restant} other {jours restants}} Depuis la recommandation`,
    DAYS_TO_DISPLAY: `Jours à afficher`,
    DBS: `DBS`,
    DEALER: `Concessionnaire`,
    DEALER_ACCOUNT: `Compte du concessionnaire`,
    DEALER_ACCOUNT_IS_REQUIRED: `Compte du concessionnaire est obligatoire`,
    DEALER_ACCOUNTS: `Comptes du concessionnaire`,
    DEALER_CITY: `Ville du concessionaire`,
    DEALER_COMMENTS: `Commentaires du concessionnaire`,
    DEALER_CONTRIBUTION: `Contribution du concessionnaire`,
    DEALER_CONTRIBUTION_IS_REQUIRED: `Contribution du concessionnaire est obligatoire`,
    DEALER_HIERARCHY_ACCOUNT: `{account} ({industryIndicator})`,
    DEALER_INVOICE_NUMBER: `Numéro de facture du concessionnaire`,
    DEALER_INVOICE_UPDATED: `Facture du concessionnaire est mise à jour`,
    DEALER_INVOICE_UPDATES: `Facture de concessionnaire`,
    DEALER_INVOICES: `Factures de concessionnaire`,
    DEALER_LOCATION: `Localisation du concessionnaire`,
    DEALER_LOCATION_FILTER: `Trier les localisations`,
    DEALER_LOCATION_IS_REQUIRED: `Localisation du concessionnaire est obligatoire`,
    DEALER_LOCATIONS: `Localisations du concessionnaire`,
    DEALER_NAME: `Nom du concessionaire`,
    DEALER_PHONE: `Numéro de téléphone concessionnaire`,
    DEALER_POSTAL_CODE: `Code postal`,
    DEALER_RECOMMENDATIONS: `Recommandations du concessionnaire`,
    DEALER_RECOMMENDATIONS_TAB: `Recommandations du concessionnaire ({count})`,
    DEALER_REVIEW_REQUEST_SUCCESSFULLY: `Réexamen du revendeur réussi`,
    DEALER_SEARCH: `Rechercher un concessionnaire`,
    DEALER_SEARCH_CHOOSE_CITY_NAME_ACCOUNT: `Saisir un nom, une ville ou un compte pour la recherche d’un concessionnaire`,
    DEALER_STATE: `Province du concessionaire`,
    DEALER_SUBMISSION_WITH_CURRENCY: `Soumission du concessionnaire ({currency})`,
    DEALER_TRANSFER_HISTORY: `L'historique de transfert de concessionnaire`,
    DEALER_TRANSFER_REQUEST_PARTIALLY_SUCCESSFUL: `Certaines demandes de transfert créées avec succès. Traiter individuellement le reste.`,
    DEALER_TRANSFER_REQUEST_SUCCESSFULLY: `Demande de transfert de revendeur en file d'attente réussie`,
    DEALER_WARRANTY: `Garantie du concessionnaire`,
    DEALERS: `Concessionnaires`,
    DEALERSHIP: `Concession`,
    DEBIT: `Débit`,
    DEBIT_AMOUNT: `Montant du débit`,
    DEBIT_FOR_CLAIM_NUMBER: `Débit pour {claimNumber}`,
    DEBIT_REQUIRED: `Debit est obligatoire`,
    DEBIT_REQUIRED_STATUS: `Statut du Débit est obligatoire`,
    DEBIT_SUBMITTED_SUCCESSFULLY: `Débit  soumis avec succès`,
    DEBIT_TYPE: `Type de débit`,
    DEBITED: `Débité`,
    DEBITS_TO_THIS_CLAIM_MUST_BE_COMPLETED_THROUGH_MANUAL_DEBIT_PROCESS: `Les débits de cette demande de garantie doivent être completés manuellement`,
    DECIMAL_FORMAT: `Format décimal`,
    DECISION_UPDATED: `Décision mise à jour`,
    DECLINE: `Refuser`,
    DEDUCTIBLE: `Franchise`,
    DEERE_REMARKS: `Remarques de John Deere`,
    DEFAULT_WARRANTY: `Garantie par défaut`,
    DEL: `Supprimer`,
    DELETE: `Supprimer`,
    DELETE_ATTACHMENT: `Supprimer le fichier joint`,
    DELETE_CLAIM: `Supprimer la demande de garantie`,
    DELETE_MACHINE_STATUS_UPDATE: `Supprimer la mise à jour de l'état de la machine`,
    DELETE_MACHINE_STATUS_UPDATE_SUCCESS: `Suppression de l'état de la machine réussie`,
    DELETE_REGISTRATION: `Supprimer l’enregistrement`,
    DELETE_REGISTRATION_SUCCESS: `L’enregistrement a été supprimé avec succès`,
    DELETED: `Supprimé(e)`,
    DELETED_BY: `Supprimé(e) By`,
    DELIVERED: `Livré(e)`,
    DELIVERED_IS_REQUIRED: `Livré(e) est obligatoire`,
    DELIVERY_DATE: `Date de livraison`,
    DELIVERY_DATE_REQUIRED: `Date de livraison est requise`,
    DELIVERY_DATES: `Date de livraison`,
    DELIVERY_NO_DOCUMENTS: `Livraison, aucun record`,
    DEMO_RENTAL_BEGIN_DATE: `Date du début de la démonstration/ location`,
    DEMO_RENTAL_CHOOSE_DEALERS_STATUS: `Sélectionner les concessionnaires et le statut`,
    DEMO_RENTAL_END_DATE: `Date de la fin de la Démonstration/Location `,
    DEMO_RENTAL_HISTORY: `Historique de location`,
    DENY: `Refuser`,
    DENY_AMOUNT_OF_USE: `Refuser la quantité d'utilisation`,
    DENY_MACHINE_STATUS_UPDATE: `Refuser la mise à jour de l’état de la machine`,
    DENY_PIP_CODE_REQUEST: `Refuser la requête de code du programme (PIP)`,
    DESCENDING: `Décroissant`,
    DESCRIPTION: `Description`,
    DESCRIPTION_OF_DAMAGE:`Description de l’endommagement`,
    DESCRIPTION_OF_EVENT_CAUSING_DAMAGE:`Description de l’événement ayant entraîné l’endommagement`,
    DESELECT_ALL: `Tout désélectionner`,
    DETAILS: `Détails`,
    DIAGNOSTICS_COVERED: `Diagnostics couvert`,
    DIS_VSR: `Afficher les messages`,
    DISPLAY: `Afficher`,
    DISPLAY_CLAIM: `Afficher la demande`,
    DISPLAY_CREDIT_MEMO: `Afficher la note de crédit`,
    DISPLAY_FORMAT: `Format d’affichage`,
    DISPLAY_PRODUCT: `Afficher le produit`,
    DISPLAY_TAG: `Afficher l'étiquette`,
    DISTANCE: `Distance`,
    DISTANCE_FROM_CURRENT_DEALER: `Distance du concessionnaire actuel`,
    DISTANCE_FROM_POTENTIAL_DEALER: `Distance du concessionnaire potentiel`,
    DISTANCE_FROM_RESPONSIBLE_ACCOUNT: `Distance Du Compte Responsable`,
    DIVISION: `Division`,
    DIVISION_SUMMARY: `Résumé de la division`,
    DO_YOU_WANT_TO_SAVE_YOUR_CHANGES: `Voulez-vous sauvegarder les modifications?`,
    DOES_NOT_CONTAIN: `Ne contient pas`,
    DOWNLOAD_TO_EXCEL: `Télécharger vers Excel`,
    DOWNTIME: `Temps d'immobilisation`,
    DOWNTIME_IS_REQUIRED: `Temps d'immobilisation requis`,
    DRAFT: `Enregistrer comme brouillon`,
    DTAC_CASE: `Cas DTAC`,
    DTAC_CASE_NUMBER: `Numéro de cas DTAC`,
    DTAC_SOLUTION: `Solution DTAC`,
    DUE_DATE: `Date d’échéance`,
    DUE_WITHIN_3_MONTHS: `Échéance dans les 3 mois`,
    DUPLICATE_PIN_PLATE: `Plaque NIP dupliquée`,
    DUPLICATE_PIN_PLATE_REPORT: `Rapport de plaque NIP dupliquée`,
    DUPLICATE_PIN_PLATE_REQUEST_UPDATED: `Demande de plaque NIP en double mise à jour`,
    DUPLICATE_PIN_PLATE_SUCCESSFULLY_CREATED: `Demande de plaque NIP dupliquée créée avec succès`,
    DUPLICATE_PIN_PLATE_WITH_COUNT: `Demande de plaque NIP en double ({count})`,
    EDIT: `Modifier`,
    EDIT_CUSTOMER: `Modifier le client`,
    EDIT_LAYOUT: `Modifier Mise en Page`,
    EDIT_WITH_PARENTHESES: `(Modifier)`,
    EFFECTIVE: `Effective`,
    EFFECTIVE_DATE: `Date d’application`,
    EMAIL: `Courier électronique`,
    EMISSIONS_PART_SEARCH: `Recherche de pièce d'antipollution`,
    END_DATE: `Date de fin`,
    END_USE: `Fin d’utilisation`,
    END_USE_CODE: `Code d'utilisation`,
    END_USE_CODE_REQUIRED: `Code de fin d’utilisation obligatoire`,
    ENDS_WITH: `Termine par`,
    ENGLISH: `Anglais`,
    ENTER_A_NUMBER_BETWEEN_0_AND_1000: `Saisir un chiffre entre 0 et 1000`,
    ENTER_A_NUMBER_BETWEEN_0_AND_10000: `Saisir un chiffre entre e 0 et 10000`,
    ENTER_A_NUMBER_FROM_1_TO_9999: `Saisir un chiffre entre 1 et 9999`,
    ENTER_A_PART_NUMBER: `Saisissez le numéro de pièce.`,
    ENTER_COMMENTS_BEFORE_ACCEPTING: `Saisir des commentaires avant d’accepter`,
    ENTITY_ID: `ID d'entité`,
    EQUALS: `Égal`,
    ERROR: `ERREUR:`,
    ERROR_MESSAGE_TITLE: `Une erreur s’est produite`,
    ERROR_MESSAGES: `Messages d'erreur`,
    ERROR_MESSAGES_TITLE: `Plusieurs erreurs sont produites:`,
    ERROR_NETWORK_ISSUES: `Une erreur de réseau a prevenu certaines données d'être chargées. Veuillez essayer à nouveau.`,
    ERROR_NO_DATA_TO_EXPORT: `Aucune donnée à exporter`,
    ERROR_RETRIEVING_CUSTOMER_INFORMATION: `Erreur lors de la récupération des informations client`,
    ERROR_SAP: `Impossible de se connecter au serveur. Si le problème persiste, cliquez sur le lien Nous contacter, pour une assistance à résoudre votre problème.`,
    ERROR_SESSION: `Votre session a expiré.  Actualisez la page pour vous reconnecter.`,
    ERROR_UNHANDLED: `Le système a rencontré une erreur inattendue. Si le problème persiste, utilisez notre fonctionnalité Aide ou cliquez sur le lien Nous contacter, pour une assistance à résoudre votre problème.`,
    ERROR_UPLOADING_FILE: `Le fichier n’était pas ajouté.`,
    ESTIMATED_BASIC_DATE: `Date d'estimée de la base`,
    ESTIMATED_BASIC_DAYS: `Jours estimés de la base`,
    ESTIMATED_HOURS: `Heures estimées`,
    ESTIMATES_MAY_NOT_REFLECT_DEMO_STATUS_OR_HOURS_NOT_YET_REPORTED: `Les estimations peuvent ne pas refléter le statut de démonstration ou les heures d'utilisation non encore rapportées`,
    EXCEEDS_DEMO_THRESHOLD: `Dépasse le seuil de la démonstration`,
    EXCHANGE_RATE: `Taux d'échange`,
    EXCLUDED_PINS_ARE_NOT_INCLUDED_IN_THIS_REPORT: `Les codes confidentiels exclus ne sont pas inclus dans ce rapport.`,
    EXECUTE: `Exécuter`,
    EXPAND_ALL: `Afficher tout`,
    EXPECTED_FIRST_USE: `Première utilisation prévue`,
    EXPIRATION_DATE: `Date d'expiration`,
    EXPIRED: `Expiré(e)`,
    EXPIRED_PART_REQUESTS: `Demandes de pièces expirées`,
    EXPIRED_PIPS: `Programmes expirés`,
    EXPIRES: `Expiré`,
    EXPIRING_SOON: `Expire sous peu`,
    EXPORT: `Exporter`,
    EXTENDED_WARRANTY: `Extension de garantie`,
    FACTORY: `USINE`,
    FACTORY_DUPLICATE_PIN_PLATE: `Plaque NIP dupliquée`,
    FACTORY_NAME: `Nom d'usine`,
    FACTORY_USERS_TAB: `Plaque NIP dupliquée ({count})`,
    FAILED: `Échoué(e)`,
    FAILED_AREA: `Zone de panne`,
    FAILED_AREA_IS_REQUIRED: `Zone de panne est obligatoire`,
    FAILED_DATE: `Date de panne`,
    FAILED_DATE_IS_REQUIRED: `Date de panne est obligatoire`,
    FAILED_MODE: `Mode de panne`,
    FAILED_MODE_COMMENTS: `Commentaires sur le mode de panne`,
    FAILED_PART: `Pièce défectueuse`,
    FAILED_PART_DESCRIPTION: `Description de pièce défectueuse`,
    FAILED_PART_IS_A_REMAN_PART: `Pièce défectueuse est une pièce ReMan`,
    FAILED_PART_IS_REQUIRED: `Pièce défectueuse est obligatoire`,
    FAILED_PART_SERIAL: `N° serie de la pièce défectueuse`,
    FAILED_PART_SERIAL_IS_REQUIRED: `N° de pièce défectueuse est obligatoire`,
    FAILURE_DATE: `Date de panne`,
    FAILURE_INFORMATION: `Informations sur la panne`,
    FAILURE_MODE: `Mode de défaillance`,
    FAILURE_MODE_IS_REQUIRED: `Mode de panne est obligatoire`,
    FAILURE_PART: `Pièce défectueuse`,
    FAILURE_PART_DESCRIPTION: `Déscription de pièce en panne`,
    FAILURE_PART_IS_REQUIRED: `Pièce défectueuse est obligatoire`,
    FAILURE_TO_RETURN_PARTS_WARNING: `Le non-retour des pièces demandées peut entraîner un débit.`,
    FAVORITES: `Favoris`,
    FILE_NAME: `Nom du fichier`,
    FILE_SIZE_IS_TOO_BIG: `Taille du fichier trop grande (taille maximale 100Mo)`,
    FILE_SIZE_IS_TOO_BIG_CSV: `Taille du fichier trop grande (taille maximale 1Mo)`,
    FILE_UPLOAD_MESSAGE: `Déposer des fichiers ici ou cliquer pour ajouter des fichiers (taille maximale: 100Mo)`,
    FILE_UPLOAD_MESSAGE_CSV: `Déposer des fichiers ici ou cliquer pour ajouter des fichiers (taille maximale: 1Mo)`,
    FILE_UPLOAD_MESSAGE_IMAGE: `Déposez des images ici ou cliquez pour ajouter des images (taille maximale: 100Mo)`,
    FILE_UPLOAD_MESSAGE_SINGLE: `Déposer un fichier ici ou Cliquer pour ajouter (Taille maximum 100Mo)`,
    FILE_UPLOAD_UNABLE_TO_READ: `Le système n'a pas pu lire votre fichier.  Comparer avec le modèle et réessayer.`,
    FILES: `Fichiers`,
    FILTER_DEALER_RECOMMENDATIONS_MESSAGE: `Aucun résultat. Appuyer sur Entrée pour rechercher toutes les recommandations.`,
    FILTER_PLACEHOLDER: `Trier les résultats`,
    FILTER_WITH_ELLIPSIS: `Filtrer`,
    FILTERED_BY_COLUMN_ID: `Trié par {columnId}`,
    FIND_CUSTOMER: `Trouver un client`,
    FINNISH: `Finnois`,
    FIRST_MAINTENANCE: `PREMIER ENTRETIEN`,
    FIRST_NAME: `Prénom`,
    FIRST_NAME_IS_REQUIRED: `Prénom obligatoire`,
    FIRST_SHIP_TO_LOCATION: `Première expédition sur site`,
    FIRST_USE: `Première utilisation`,
    FISCAL_YEAR: `Année fiscal`,
    FLUID_SAMPLING_REQUIRED: `Échantillon de fluide requis`,
    FORWARDED: `Transféré(e)`,
    FRENCH: `Français`,
    FROM: `De`,
    FRWRD: `Transférer`,
    FULL_DEBIT: `Débit complet`,
    GENERAL: `Général`,
    GERMAN: `Allemand`,
    GET_MAINTENANCE_PLANS: `Obtenir les programmes d’entretien`,
    GOODS_INSTALLATION_VAT: `TVA d’installation`,
    GRACE_PERIOD: `Période de Grâce`,
    GREATER_THAN: `Supérieur à`,
    GREATER_THAN_OR_EQUALS: `Supérieur ou égal à`,
    GROUP_COMPLETE: `Groupe terminé`,
    GST_PERCENTAGE: `GST Pourcentage`,
    H_LIMIT: `Heure limite`,
    HISTORY_TO_DISPLAY: `Historique à afficher (jours)`,
    HOME: `Accueil`,
    HOUR_LIMIT: `Heure limite`,
    HOURS: `Heures`,
    HOURS_ON_RENT: `Heures de location`,
    HSN_SAC_CODE: `HSN/SAC Code`,
    IGST: `IGST`,
    IMPLEMENTS: `Équipements`,
    IN_RANGE: `Dans l'intervalle`,
    INCENTIVE: `Motivation`,
    INCENTIVE_PROGRAMS: `Programmes incitatifs`,
    INCLUDE_FULLY_COMPLETE: `Inclure des PIP complets`,
    INDICATES_REQUIRED_FIELD: `Indique un champ obligatoire`,
    INFO_MESSAGE_TITLE: `Une notification du système a été envoyée`,
    INFO_MESSAGES: `Messages d’information`,
    INFO_MESSAGES_TITLE: `Plusieurs notifications du système ont été envoyées`,
    INFO_REQUEST_STATUS_ERROR: `L'information est prête à être soumise avec cette application.`,
    INFORMATION: `Information`,
    INFORMATION_REQUEST: `Demande d'information`,
    INFORMATION_REQUEST_STATUS: `Statut de la demande d'information`,
    INPUT_PIN: `Saisir le NIP`,
    INSPECTION: `Inspection`,
    INSTALLED_BY: `Installé(e) Par`,
    INSTALLED_BY_IS_REQUIRED: `Installé(e) Par est obligatoire`,
    INTERNAL_DEERE_COMMENTS: `Commentaires internes de Deere`,
    INTERNAL_EQUIPMENT_NOTES: `Remarques sur les équipements internes`,
    INTERVAL_BEGINS: `Commencement de l'internvalle`,
    INTERVAL_ENDS: `Fin de l’intervalle`,
    INTERVAL_TYPE_DESCRIPTION: `Description du type d’intervalle`,
    INVOICE_ACCOUNT: `Compte de facturation`,
    INVOICE_DEALER: `Concessionnaire facturé`,
    INVOICE_NUMBER: `Numéro de facture`,
    INVOICE_REQUEST: `Demande de facture`,
    INVOICE_SENT: `Facture envoyée`,
    INVOICE_UPDATED_SUCCESSFULLY: `Fatura mis à jour avec succés`,
    INVOICED: `Facturé(e)`,
    INVOICED_TO: `Facturé(e) à`,
    IRC_PIN_MESSAGE: `Le client est un IRC & a droit à des frais de déplacement et kilométrage gratuits pour les 500 premières heures ou 12 mois de propriété de la machine.`,
    ISSUED: `Émis(e)`,
    ITALIAN: `Italien`,
    ITEM: `Article`,
    ITEM_NUMBER: `Numéro du matériel`,
    ITEM_NUMBER_IS_REQUIRED: `Numéro du matériel obligatoire`,
    JDLINK_EXPIRES: `JDLink expire`,
    JDP_COMMENTS: `Commentaires de JDP`,
    JDP_COMMENTS_IS_REQUIRED: `Commentaires JDP est obligatoire`,
    JDP_CUSTOMER_RESOLUTION: `Résolution du client JDP`,
    JDP_CUSTOMER_RESOLUTION_IS_REQUIRED: `Résolution de client JDP est obligatoire`,
    JDP_REASON: `Raison de JDP`,
    JDP_REASON_IS_REQUIRED: `Raison JDP est obligatoire`,
    LABOR: `Main d'œuvre`,
    LABOR_ADDITIVE: `Additif de main d'œuvre`,
    LABOR_ADDITIVE_COMPLETION_DETAIL: `Détails d'achèvement de l'additif de main d'œuvre`,
    LABOR_ADDITIVE_PIPS: `Additif de main d'œuvre des Programmes (PIP)`,
    LABOR_ADDITIVE_TAB: `Additif de main d'œuvre ({count})`,
    LABOR_ADJUSTMENT: `Réglage de la main-d'oeuvre`,
    LABOR_COMMENTS: `Commentaires de Main d'œuvre`,
    LABOR_HOURS: `Main d'œuvre`,
    LABOR_ITEM_DETAILS: `Main d’œuvre - {quantity} {unit} {description}`,
    LABOR_RATE_APPROVED_SUCCESSFULLY: `Tarif de main-d'œuvre approuvé avec succès`,
    LABOR_RATE_CHANGE_SUBMITTED: `Modification du tarif de main-d’œuvre soumise`,
    LABOR_RATE_CHANGES_WITH_COUNT: `Modifications du tarifs de main-d’œuvre ({count})`,
    LABOR_RATE_CONFIRM: `Le tarif demandé est inférieur au tarif actuel. Êtes-vous sûr de vouloir soumettre la demande?`,
    LABOR_RATE_DIFFERENCE_LARGE_INFORMATION_MESSAGE: `Les taux en rouge indiquent une augmentation de plus de 10 % par rapport au taux existant`,
    LABOR_RATE_HISTORY: `Historique des tarifs de main-d’œuvre`,
    LABOR_RATE_REJECTED_SUCCESSFULLY: `Tarif de main-d’œuvre refusé`,
    LABOR_RATE_REQUESTS_STATUS: `Statut des demandes de taux de travail`,
    LABOR_RATE_RETURNED_SUCCESSFULLY: `Taux de main-d'oeuvre renvoyé avec succès`,
    LABOR_RATES: `Tarifs de main-d’œuvre`,
    LABOR_STATS: `Statistiques de main-d’œuvre`,
    LABOR_TOTAL: `Main-d’œuvre totale`,
    LABOR_TYPE: `Type de main-d’œuvre`,
    LABOR_VALUE: `Valeur de la main d’œuvre`,
    LABOR_WITH_COUNT: `Main d’œuvre ({count})`,
    LANGUAGE: `Langue`,
    LAST_LOCATION_FROM: `Dernier emplacement à partir de`,
    LAST_NAME: `Nom`,
    LAST_NAME_IS_REQUIRED: `Nom est obligatoire`,
    LAST_PERSONAL_CONTACT: `Dernier contact personnel`,
    LAST_SEEN: `Dernière vue`,
    LAST_SEEN_AT_RESPONSIBLE_ACCOUNT: `Dernière Vue Sur Le Compte Responsable`,
    LATEST: `Dernier`,
    LAW_ENFORCEMENT_AGENCY_DETAILS: `Détails de l'Agence de Police`,
    LAYOUT_CREATED_SUCCESSFULLY: `Mise en page créée avec succès`,
    LAYOUT_DELETED_SUCCESSFULLY: `Mise en page supprimée avec succès`,
    LAYOUT_NAME: `Nom de la mise en page`,
    LAYOUT_UPDATED_SUCCESSFULLY: `Mise en page mise à jour avec succès`,
    LEAD_ACCOUNT: `Compte principal`,
    LEAD_DEALER: `Concessionnaire principal`,
    LESS_THAN: `Moins de`,
    LESS_THAN_OR_EQUALS: `Inférieur(e) ou égal(e) à`,
    LICENSE_PLATE_NUMBER: `Numéro de plaque d'immatriculation`,
    LIFETIME: `Garantie à vie`,
    LINE_ITEMS_EXPORT: `Exportation d'éléments de campagne`,
    LIST: `Liste`,
    LIST_TOTAL: `Total liste`,
    LOCATION: `Localisation`,
    LOCATION_DUE: `Localisation est Obligatoire`,
    LOCATIONS: `Localisations`,
    LOCATIONS_WITH_COUNT: `Localisations ({count})`,
    MACHINE_ALREADY_REGISTERED_TO_THIS_CUSTOMER: `Machine déjà enregistrée à ce client`,
    MACHINE_INFORMATION: `Information de la machine`,
    MACHINE_MODEL_TYPE: `Modèle/type de machine`,
    MACHINE_MODEL_TYPE_REQUIRED: `Modèle/type de machine requis`,
    MACHINE_STATUS: `Statut de la machine`,
    MACHINE_STATUS_UPDATE: `Mise à jour de l'état de la machine`,
    MACHINE_STATUS_UPDATE_ACCEPTED: `Mise à jour du statut de la machine approuvée`,
    MACHINE_STATUS_UPDATE_DOCUMENT: `Document de mise à jour du statut de la machine`,
    MACHINE_STATUS_UPDATE_REJECTED: `Mise à jour du statut de la machine refusée`,
    MACHINE_STATUS_UPDATES_WITH_COUNT: `Mises à jour du statut de de la machine ({count})`,
    MACHINE_TYPE: `Type de Machine`,
    MACHINE_TYPE_IS_REQUIRED: `Type de Machine est obligatoire`,
    MACHINE_USE: `Usage de la machine`,
    MAILING_RECIPIENT: `Destinataire du publipostage (prénom et nom)`,
    MAILING_RECIPIENT_REQUIRED: `Destinataire de publipostage requis`,
    MAINTENANCE: `Maintenance`,
    MAINTENANCE_PLAN: `Programmes d’entretien`,
    MAINTENANCE_PLAN_INFO: `Information sur le programme d’entretien`,
    MARK_AS_INPROCESS: `Marquer comme en cours`,
    MARK_AS_REVIEW: `Marquer comme révisé`,
    MARKETING_INCENTIVE: `Marketing - Motivation`,
    MARKETING_JD_PROMISE: `Marketing - Promesse JD`,
    MARKETING_MAINTENANCE_PLAN: `Marketing - Programme d’entretien`,
    MARKETING_MASS_CHANNEL_FOLLOWUP: `Marketing - Vente en masse, Suivi`,
    MARKETING_MASS_CHANNEL_PDI: `Marketing - Vente en masse, PDI`,
    MASS_CHANNEL_CUSTOMER_FOLLOW_UP: `Client de vente en masse -suivi`,
    MASS_CHANNEL_CUSTOMER_FOLLOW_UP_HELP_TEXT: `Rappel: veuillez contacter votre conseiller juridique pour les procédures de "Ne Pas Appeler"  au sein de votre region  ou au niveau fédéral avant de faire un appel de suivi après vente.`,
    MASS_CHANNEL_PDI_CLAIM: `Vente en gros - PDI`,
    MASTER_WARRANTY_TYPE: `Type de garantie principale`,
    MATERIAL: `Numéro de matériau`,
    MERCHANDISE: `Marchandise`,
    MESSAGE: `Message`,
    MESSAGES: `Messages`,
    METHOD_OF_CONTACT: `Méthode de contact`,
    METHOD_OF_CONTACT_IS_REQUIRED: `Le champ Méthode de contact est obligatoire`,
    METRIC: `Indicateur de pénalité`,
    METRICS: `Indicateurs de pénalité`,
    MILEAGE_LIMIT: `Limite de kilométrage`,
    MOBILE_PHONE: `Téléphone mobile`,
    MODEL: `Modèle`,
    MODEL_NUMBER: `Numéro de modèle`,
    MODEL_YEAR: `Année modèle`,
    MODIFIED: `Modifié(e)`,
    MONTH_TO_DATE: `Mois à ce jour`,
    MORE: `Plus`,
    MULTIPLE: `multiple`,
    NAME: `Nom`,
    NET: `Net`,
    NET_AMOUNT: `Montant net`,
    NET_AMOUNT_PAID: `Montant net payé`,
    NET_TOTAL: `Total net`,
    NEW: `Nouvelle`,
    NEW_ACCOUNT: `Nouveau compte`,
    NEW_CLAIM: `Nouvelle demande de garantie`,
    NEW_CLAIM_VALUE: `Nouvelle valeur de demande`,
    NEW_CUSTOMER_REQUIRED: `Nouveau Cient obligatoire`,
    NEW_DEALER: `Nouveau concessionnaire`,
    NEW_DEALER_DISTANCE: `Nouvelle distance de revendeur`,
    NEW_DEALER_LOCATION: `Localisation du nouveau concessionnaire`,
    NEW_LABOR_RATE: `Nouvel  tarif de main-d’œuvre`,
    NEW_REQUEST_ENTER_RATES: `Nouvelle demande - Entrer les taux`,
    NEW_STATUS: `Nouveau statut`,
    NEW_TRANSFER: `Nouveau transfert`,
    NEW_TRANSFER_CREATED: `Nouveau transfert créé`,
    NEW_VALUE: `Nouvelle valeur`,
    NO: `Non`,
    NO_ACTIVE_WARRANTY: `Pas de garantie active`,
    NO_AFFECTED_PINS: `Aucun NIP sous la responsabilité de votre concession n'est affecté`,
    NO_AUTHORITY_TO_ACCESS: `Vous n'avez pas le droit d'accéder au JDWS. Les utilisateurs de la fonction de concessionnaire s'il vous plaît faire un suivi auprès de votre administrateur de profil (DPA) pour vérifier l'autorité et les utilisateurs de Deere contacter le support avec une copie de cette erreur ici`,
    NO_CLAIMS: `Il n’y a aucune demande de garantie`,
    NO_CUSTOMER_ASSOCIATED: `Aucun(e) client(e) n’est associé(e)`,
    NO_CUSTOMER_SELECTED: `Pas de client(e) sélectionné(e)`,
    NO_DEALER_INVOICES: `Aucune facture de concessionnaire`,
    NO_DEALERS_MAPPED: `Aucun concessionnaire n’est associé à votre identifiant. Contactez l’administrateur du système.`,
    NO_IF_NO_A_PICTURE_MUST_BE_PROVIDED_AS_EVIDENCE:`Non (fournir une preuve par photo)`,
    NO_INFORMATION_AVAILABLE_FOR_THIS_PRODUCT: `Aucune information disponible pour ce produit`,
    NO_LABOR_COVERAGE: `Pas de couverture de main-d'œuvre`,
    NO_LOWERCASE: `Non`,
    NO_MATCHING_DEALERS: `Aucun concessionnaire ne correspond au triage de text.`,
    NO_OPEN_PART_REQUESTS: `Aucune demande de pièce ouverte`,
    NO_OPEN_PIPS: `Aucun  Programme (PIP) ouvert`,
    NO_PARTS_RETURNED: `Aucune Pièce Retournée`,
    NO_PIP_PRODUCTS: `Aucun produit du programme (PIP)`,
    NO_PRODUCT_FOUND: `Aucun produit trouvé`,
    NO_REQUIRED_ITEMS: `Il n'y a pas d'articles obligatoires`,
    NO_RESULTS: `Aucun résultat`,
    NO_RESULTS_FOUND: `Aucun résultat trouvé`,
    NO_ROWS_TO_SHOW: `Pas de rangées à afficher`,
    NO_SPECIAL_INSTRUCTIONS: `Il n’y a pas d' instructions spéciales`,
    NO_TRAVEL: `Pas de déplacement`,
    NON_RECOVERABLE_TAXES: `Taxes non récupérables`,
    NON_TRACKED_PINS_HELP_TEXT: `Certains produits n’apparaissent dans la garantie qu’après l’enregistrement. Votre recherche correspond à une gamme de ces produits.`,
    NON_TRAVEL: `Pas de déplacement`,
    NONE: `Aucun`,
    NORMAL: `NORMALE`,
    NOT_EQUAL: `Inégal`,
    NOTIFICATION_ADDED_SUCCESSFULLY:`Notification ajoutée avec succès`,
    NOTIFICATION_DELETED_SUCCESSFULLY:`Notification supprimée avec succès`,
    NOTIFICATION_SEQUENCE_UPDATED_SUCCESSFULLY: `Séquence de notification mise à jour avec succès`,
    NOTIFICATION_UPDATED_SUCCESSFULLY:`Notification mise à jour avec succès`,
    NOTIFICATIONS: `Notifications`,
    NUMBER_OF_DIAGNOSTICS_OCCURRENCES: `Nombre d’occurrences de diagnostic`,
    NUMBER_OF_OPEN_PIPS: `{number} programmes d’amélioration (PIP) actifs`,
    NUMBER_OF_REPAIR_OCCURRENCES: `Nombre d’occurrences de réparation`,
    NUMBER_OF_REPLACEMENT_OCCURRENCES: `Nombre d’occurrences de remplacement`,
    OLD_LABOR_RATE: `Ancien tarif de main-d’œuvre`,
    ON_SHELF: `Stockage`,
    ON_SHELF_COST: `Coûts de stockage`,
    ONE_ITEM_MUST_BE_SELECTED: `Un élément doit être sélectionné`,
    OPEN: `Ouvrir`,
    OPEN_PART_REQUESTS: `Demandes en retour de pièces actives`,
    OPEN_PART_REQUESTS_WITH_COUNT: `Demandes en retour de pièces actives ({count})`,
    OPEN_PIP_COUNT: `Nombre de PIP ouverts`,
    OPEN_PIP_PROGRAMS: `Registre de Programme`,
    OPEN_PIPS: `Programmes (PIP) actifs`,
    OPEN_PIPS_REPORT: `Rapport du Programme d'Amelioration Non Accompli`,
    OPEN_PIPS_TAB: `Ouvrir les PIP ({count})`,
    OPEN_PIPS_Y_N: `Programmes d'amélioration (PIP) ouverts (O/N)`,
    OPERATORS_COMPLAINT: `Quelle était la plainte de l’opérateur?`,
    OPERATORS_COMPLAINT_IS_REQUIRED: `Réclamation de l’opérateur requise`,
    OPERATORS_MANUAL_NUMBER: `Numéro du manuel de l'opérateur`,
    OPTION_CODE: `Code d'option`,
    OPTION_CODE_CREATED_SUCCESSFULLY: `Code d'option créé avec succès`,
    OPTION_CODE_DELETED_SUCCESSFULLY: `Codes d'option supprimé avec succès`,
    OPTION_CODES: `Codes d'option`,
    OR: `ou`,
    ORIGINAL_CLAIM_VALUE: `Valeur de la réclamation d'origine`,
    ORIGINAL_SUBMISSION_DATE: `Date originale de soumission`,
    ORIGINALLY_SUBMITTED: `Initialement soumis(e)`,
    OTHER: `Autre`,
    OTHER_AMOUNT_OF_USE: `Autre Nombre d’Usage`,
    OTHER_AMOUNT_OF_USE_REQUIRED: `Autre Nombre d’Usage est obligatoire`,
    OTHER_CREDIT: `Autres Crédits`,
    OTHER_CREDIT_1: `Autres Crédits 1`,
    OTHER_CREDIT_2: `Autres Crédits 2`,
    OTHER_CREDIT_3: `Autres Crédits 3`,
    OTHER_CREDIT_ADJUSTMENT: `Ajustement d'autres crédits`,
    OTHER_CREDIT_ITEM_DETAILS: `Autres Crédits - {description} ({quantity} {unit})`,
    OTHER_CREDIT_TOTAL: `Total d'autre crédit`,
    OTHER_CREDITS: `Autres Crédits`,
    OTHER_CREDITS_WITH_COUNT: `Autres crédits ({count})`,
    OTHER_INSTRUCTIONS: `Autres instructions`,
    OUTPUT_PIN: `NIP de production`,
    OVERDUE: `En retard`,
    OVERRIDE_ACCOUNT: `Remplacer le compte`,
    OVERRIDE_EFFECTIVE_DATE: `Substituer la date d'entrée en vigueur`,
    OVERRIDE_SUGGESTED_ACCOUNT: `Passage en mode manuel forcé du compte suggéré`,
    OWNERSHIP_STATUS: `Statut de la propriété`,
    OWNERSHIP_STATUS_IS_REQUIRED: `Statut de Propriété est obligatoire`,
    PART: `Pièce`,
    PART_1: `Pièce 1`,
    PART_2: `Pièce 2`,
    PART_3: `Pièce 3`,
    PART_4: `Pièce 4`,
    PART_5: `Pièce 5`,
    PART_6: `Pièce 6`,
    PART_7: `Pièce 7`,
    PART_8: `Pièce 8`,
    PART_9: `Pièce 9`,
    PART_10: `Pièce 10`,
    PART_AMONT_OF_USE: `Durée d’utilisation de pièce`,
    PART_FAMILY: `Famille de pièces`,
    PART_ITEM_DETAILS: `Pièces - {quantity} {description} N° de pièce {partNumber}`,
    PART_NUMBER: `Numéro de pièce`,
    PART_REQUEST: `Demande de retour de pièce`,
    PART_REQUEST_NUMBER: `Demande de retour de pièce {rgaNumber}`,
    PART_REQUEST_STATUS: `Statut de la demande de retour de pièce`,
    PART_REQUESTS: `Demandes de retour de pièce`,
    PART_REQUESTS_SEARCH_BY_CLAIM_PLACEHOLDER: `Saisir le numéro de la demande de garantie, 4 caractères au minimum`,
    PART_REQUESTS_SEARCH_BY_CLAIM_VALIDATION_ERROR: `La recherche de demande de garantie doit contenir 4 caractères au minimum`,
    PART_REQUESTS_SEARCH_BY_DTAC_CASE_NUMBER_ERROR: `La recherche de numéro de cas DTAC doit contenir le numéro complet du cas DTAC, 4 caractères au minimum`,
    PART_REQUESTS_SEARCH_BY_DTAC_CASE_NUMBER_PLACEHOLDER: `Saisir le numéro complet du cas DTAC`,
    PART_REQUESTS_SEARCH_BY_PART_NUMBER_ERROR: `La recherche de numéro de Pièce doit contenir 4 caractères au minimum`,
    PART_REQUESTS_SEARCH_BY_PART_NUMBER_PLACEHOLDER: `Saisir le numéro de piece, 4 caractères au minimum`,
    PART_REQUESTS_SEARCH_BY_PART_REQUEST_ERROR: `La recherche de numéro de demande de retour de pièce doit contenir 4 caractères au minimum`,
    PART_REQUESTS_SEARCH_BY_PART_REQUEST_PLACEHOLDER: `Saisir le numéro de pièce demandée en retourd, 4 caractères au minimum`,
    PART_REQUESTS_SEARCH_BY_PIN_ERROR: `La recherche de NIP doit contenir 4 caractères au minimum`,
    PART_REQUESTS_SEARCH_BY_PIN_PLACEHOLDER: `Saisir le NIP, 4 caractères au minimum`,
    PART_REQUESTS_SEARCH_BY_WORK_ORDER_ERROR: `La recherche de l'ordre de travail doit contenir l’ordre complet, 2 caractères au minimum`,
    PART_REQUESTS_SEARCH_BY_WORK_ORDER_PLACEHOLDER: `Saisir l'ordre de reparation complet`,
    PART_REQUESTS_UPDATED_SUCCESSFULLY: `Demande de retour de pièce mise à jour avec succès`,
    PART_RETURN: `Pièce retournée`,
    PART_RETURNS: `Pièces retournées`,
    PART_SERIAL_NUMBER: `Numéro de série de la pièce`,
    PART_SERIAL_NUMBER_IS_REQUIRED: `Numéro de série de la Pièce est obligatoire`,
    PART_TOTAL: `Total de pièce`,
    PART_TYPE: `Type de pièce`,
    PART_USE: `Nombre d'usage de pièce`,
    PART_VALUE: `Valeur de la pièce`,
    PARTIAL_DEBIT: `Débit partiel`,
    PARTICIPANT: `Participant`,
    PARTS: `Pièces`,
    PARTS_ADDITIVE: `Additif de pièces`,
    PARTS_ADJUSTMENT:`Réglage des pièces`,
    PARTS_COVERAGE_SEARCH: `Recherche sur la couverture des pièces`,
    PARTS_TEMPLATE: `Gabarit des pièces`,
    PARTS_USE: `Nombre d'usage de pièces`,
    PARTS_USE_IS_REQUIRED: `Utilisation des pièces est obligatoire`,
    PARTS_WITH_COUNT: `Pièces ({count})`,
    PARTS_WITH_PARENTHESES: `Pièce(s)`,
    PAST_DUE: `En retard`,
    PAYER_ACCOUNT: `Compte payeur`,
    PC_LIMIT:`Limite de balle`,
    PERCENT_COMPLETE: `Pourcentage achevé`,
    PERCENTAGE: `Pourcentage`,
    PERCENTAGE_DEBIT: `Pourcentage de débit`,
    PERCENTAGE_SYMBOL: `{percentage}%`,
    PERCENTAGE_TO_DEBIT: `Pourcentage de débit`,
    PERMANENTLY_OUT_OF_SERVICE_MACHINES_HELP_TEXT:`Dans le cas d’une machine définitivement HS, veuillez joindre une photo de la machine permettant de confirmer qu’elle ne pourra plus jamais être remise à neuf, réparée ou réutilisée. Les machines définitivement HS ne peuvent faire l’objet d’aucun PIP.`,
    PERSON_RESPONSIBLE: `La personne responsable`,
    PHONE: `Téléphone`,
    PHONE_REQUIRED: `Téléphone requis`,
    PICTURE: `Image`,
    PICTURE_REQUEST: `Demande d'image`,
    PICTURE_REQUEST_STATUS: `Statut de la demande d'image`,
    PICTURE_REQUEST_STATUS_ERROR: `Les pièces jointes sont prêtes à être soumises avec cette demande.`,
    PIN: `NIP`,
    PIN_CREATED_SUCCESSFULLY: `NIP créé avec succès`,
    PIN_CROSS_REFERENCE: `Référence croisée de NIP`,
    PIN_INVALID: `NIP invalide`,
    PIN_IS_REQUIRED: `NIP est Obligatoire`,
    PIN_REQUIRED: `NIP obligatoire`,
    PIN_SEARCH: `Recherche de broches`,
    PIN_SEARCH_INFORMATION: `Informations de recherche de broches`,
    PIN_TRANSFER_INFORMATION: `Informations sur le transfert de broches`,
    PINS: `NIPs`,
    PINS_NOT_REGISTERED: `NIPs non enregistrés`,
    PIP: `Programme (PIP)`,
    PIP_CODE: `Code PIP`,
    PIP_CODE_CREATED_SUCCESSFULLY: `Demande de code PIP créée avec succès`,
    PIP_CODE_REQUEST: `Demande de code du programme (PIP)`,
    PIP_CODE_REQUEST_APPROVED: `Demande de code du programme (PIP) approuvée`,
    PIP_CODE_REQUEST_REJECTED: `Demande de code du programme (PIP) refusée`,
    PIP_CODE_REQUESTS_WITH_COUNT: `Demandes de code du programme (PIP) ({count})`,
    PIP_COMPLETION_STATUS: `Statut des programmes effectués`,
    PIP_DETAILS: `Détails du programme (PIP)`,
    PIP_HISTORY: `Historique du programme (PIP)`,
    PIP_ID: `N° du programme (PIP)`,
    PIP_NUMBER: `Numéro de programme (PIP)`,
    PIP_PROGRAM: `Programme PIP`,
    PIP_PROGRAM_IS_REQUIRED: `Programme PIP est obligatoire`,
    PIP_PROGRAMS: `Programmes PIP`,
    PIP_SEARCH: `Recherche du programme`,
    PIP_STATUS: `Statut du programme (PIP)`,
    PIP_TYPE: `Type de Programme (PIP)`,
    PIP_TYPES: `Types de Programme (PIP)`,
    PIPS: `Programmes (PIP)`,
    PIPS_UNPAID_LABOR_ADDITIVE: `Additif impayé sur la main-d’œuvre des programmes (PIP)`,
    PLAN_DESCRIPTION: `Description du plan`,
    PLAN_END_DATE: `Date de fin du plan`,
    PLAN_ENDS: `Fin du plan`,
    PLAN_NAME: `Nom du plan`,
    PLAN_NAME_IS_REQUIRED: `Nom du plan est obligatoire`,
    PLAN_NAMES: `Noms du plan`,
    PLAN_START_DATE: `Date de début du plan`,
    PLAN_STARTS: `Début du plan`,
    PLANNED_BY: `Prévu(e)`,
    PLANT: `Usine`,
    PLATE_REQUEST_INFORMATION: `Informations sur la demande de plaque`,
    PLEASE_SELECT_A_LEAD_ACCOUNT: `Veuillez sélectionner un compte principal`,
    PLEASE_SELECT_CLAIM_TYPE: `Veuillez sélectionner le type de demande de garantie`,
    POLISH: `Polonais`,
    PORTUGUESE: `Portugais`,POSTAGE_DELIVERY_DATE: `Date de livraison du courrier`,
    POSTAL_CODE: `Code postal`,
    POSTAL_CODE_REQUIRED: `Code postal requis`,
    POSTAL_TRACKING_NUMBER: `Numéro de suivi postal`,
    POTENTIAL_RESPONSIBLE_DEALER: `Vendeur responsable potentiel`,
    PRE_DELIVERY_INSPECTION: `Inspection avant livraison`,
    PREFERRED_THEME: `Thème préféré`,
    PREPARE_AUDIT: `Préparer audit`,
    PREPARED: `Préparé(e)`,
    PREPARING_AUDIT_FOR_WITH_DEALER: `Préparation d’audit pour {dealer}`,
    PREVIOUS_AMOUNT_OF_USE: `Durée d’Utilisation précédent`,
    PREVIOUS_INVOICE_NUMBER: `Numéro de facture précédente`,
    PREVIOUS_INVOICE_NUMBER_IS_REQUIRED: `Numéro de facture précédente est obligatoire`,
    PREVIOUS_MONTH: `Mois précédent`,
    PRICE: `Prix`,
    PRICING_SUMMARY: `Résumé des prix`,
    PRIMARY_ACTION: `Action principale`,
    PRIMARY_LANGUAGE: `Langue principale`,
    PRINT: `Imprimer`,
    PRINT_CLAIM: `Imprimer la demande de garantie`,
    PRINT_REGISTRATION_FORM: `Imprimer le Formulaire d'inscription`,
    PRINT_REGISTRATION_FORM_MESSAGE: `Produit enregistré au premier propriétaire. Voulez-vous imprimer le formulaire d'inscription maintenant?`,
    PRINT_TO_PDF: `Imprimez PDF`,
    PRIORITY: `Priorité`,
    PRNT_CLM: `Afficher la demande de garantie`,
    PROCESS_DATE: `Date de traitement`,
    PROCESSED: `Traité(e)`,
    PROCESSED_PART_REQUESTS: `Demandes de pièces traitées`,
    PROCESSING_STATUS: `Statut de traitement`,
    PROCESSING_STATUS_DESCRIPTION: `Description du statut de traitement`,
    PRODUCT_DETAILS: `Détails des produits`,
    PRODUCT_HIERARCHY: `Hiérarchie des produits`,
    PRODUCT_INFORMATION: `Information du produit`,
    PRODUCT_REGISTERED: `Produit enregistré`,
    PRODUCT_REGISTRATION: `Enregistrement de produit`,
    PRODUCT_REGISTRATION_PENDED: `L 'enregistrement du produit est suspendu`,
    PRODUCT_TRACKING: `Suivi du produit`,
    PRODUCTS: `Produits`,
    PRODUCTS_BY_CUSTOMER: `Produits par client`,
    PRODUCTS_BY_CUSTOMER_PARTIAL_DATA_WARNING: `Les codes PIN historiques peuvent être manquants dans les résultats de recherche en raison d'un problème de connectivité système temporaire.`,
    PRODUCTS_WITH_COUNT: `Produits ({count})`,
    PROGRAM: `Programme`,
    PROGRAM_DESCRIPTION: `Description du programme`,
    PROGRAM_IS_REQUIRED: `Le nom du programme est requis.`,
    PROGRAM_NAME: `Nom du programme`,
    PROGRAM_NAME_IS_REQUIRED: `Le nom du programme est requis.`,
    PROGRAM_NUMBER: `Numéro de programme`,
    PRT: `Suivi de produit`,
    PRTS: `Suivi de produit`,
    PURCHASE_INFO: `Informations sur l’achat`,
    PURCHASE_ORDER: `Bon de commande`,
    PURCHASE_ORDER_IS_REQUIRED: `Bon de commande est obligatoire`,
    PURCHASER_TYPE: `Type d'acheteur`,
    PURCHASER_TYPE_REQUIRED: `Type d’acheteur obligatoire`,
    PUSH_XML: `Réenvoyer XML`,
    QTY: `Qté`,
    QUALIFY_FOR_EMISSIONS: `Qualifié(e) pour les antipollutions`,
    QUANTITY: `Quantité`,
    QUANTITY_1: `Quantité 1`,
    QUANTITY_2: `Quantité 2`,
    QUANTITY_3: `Quantité 3`,
    QUANTITY_4: `Quantité 4`,
    QUANTITY_5: `Quantité 5`,
    QUANTITY_6: `Quantité 6`,
    QUANTITY_7: `Quantité 7`,
    QUANTITY_8: `Quantité 8`,
    QUANTITY_9: `Quantité 9`,
    QUANTITY_10: `Quantité 10`,
    QUERY_MUST_CONTAIN_3_CHARACTERS: `La requête doit contenir au moins 3 caractères`,
    QUEST_DESC: `Description douteuse`,
    QUESTIONABLE_PART: `Pièce Douteuse`,
    QUEUED: `En file d'attente`,
    READING_DATE: `Date de relevé`,
    REASON: `Raison`,
    REASON_EVENT_NUMBER: `Raison du numéro d'événement`,
    REASON_FOR_CHANGE: `Raison du changement`,
    REASON_FOR_DEBIT: `Raison du débit`,
    REASON_FOR_MISSING_PLATE: `Raison de la plaque manquante`,
    REASON_FOR_MISSING_PLATE_REQUIRED: `Raison de l'absence de plaque requise`,
    REASON_FOR_OVERRIDE: `Raison de la substitution`,
    REASON_FOR_REFUSAL: `Raison du refus`,
    REASON_FOR_RETURN: `Raison du retour`,
    REASON_FOR_RETURN_IS_REQUIRED: `Raison du retour est obligatoire`,
    REASON_FOR_TRANSFER: `Raison du transfert`,
    REASON_FOR_TRANSFER_MUST_CONTAIN_ALPHANUMERIC_CHARACTERS: `La raison du  transfert doit contenir des caractères alphanumériques`,
    REASON_FOR_TRANSFER_REJECTION: `Raison du rejet du transfert`,
    RECIPIENT_DEALER_OR_TCSM: `Destinataire (concessionnaire ou TCSM/MRSC)`,
    RECIPIENT_MAILING: `Destinataire du publipostage`,
    RECOMMENDATION: `Recommandation`,
    RECOMMENDATION_DATE: `Date de recommandation`,
    RECOMMENDED_ACCOUNT: `Compte recommandé`,
    RECONCILE: `Réconcilier`,
    RECONCILE_CLAIM: `Reconcilier la demande de garantie`,
    RECONCILED: `Réconcilié(e)`,
    RECORD_AUDIT: `Enregistrer l’audit`,
    RECORD_AUDIT_FOR: `Enregistrer l’audit pour {dealer}`,
    RECORDS_FOUND: `{countToDisplay} {count, plural, one {document trouvé} other {documents trouvés}}`,
    RECOVERABLE_TAXES: `Taxes récupérables`,
    RECOVERED: `Récupéré(e)`,
    RECOVERED_WITH_MISSED_ADDITIVES: `Récupéré(e) avec des additifs manqués`,
    RECOVERED_WITHOUT_ADDITIVES: `Récupéré(e) sans additifs`,
    RECOVERY: `Récupération`,
    RED_MUST_BE_LESS_THAN_YELLOW: `La valeur de l’indicateur rouge doit être inférieure à celle de l’indicateur jaune.`,
    REFERENCE_1: `Référence 1`,
    REFERENCE_2: `Référence 2`,
    REFERENCE_INFORMATION: `Informations de référence`,
    REFERENCE_NUMBER1: `Numéro de référence 1`,
    REFERENCE_NUMBER2: `Numéro de référence 2`,
    REGION: `Région`,
    REGISTER: `Enregistrer`,
    REGISTER_A_PRODUCT_BY_PIN: `Enregistrer un produit par NIP`,
    REGISTER_A_PRODUCT_TO_ADD: `Enregistrer le produit à ajouter au système de garantie`,
    REGISTER_ANOTHER_PRODUCT: `Enregistrer un autre produit`,
    REGISTER_PRODUCT: `Enregistrer le produit`,
    REGISTER_PRODUCT_AND_REGISTER_ANOTHER: `Enregistrer le produit et enregistrer un autre`,
    REGISTERED: `Enregistré(e)`,
    REGISTRATION: `Enregistrement`,
    REGISTRATION_DATE: `Date d'enregistrement`,
    REGISTRATION_DATES: `Dates d’enregistrement`,
    REGISTRATION_FORM: `Formulaire d’enregistrement`,
    REGISTRATION_HISTORY: `Historique d'enregistrement`,
    REGISTRATION_NOT_ALLOWED: `Enregistrement non autorisé pour ce produit`,
    REGISTRATION_REVIEW: `Révision de l'enregistrement`,
    REGISTRATION_REVIEW_TAB: `Révision de l'enregistrement ({count})`,
    REGISTRATION_STATUS: `Statut de l'enregistrement`,
    REGISTRATION_STATUS_CANNOT_BE_NEW: `Le statut d'enregistrement ne peut pas être Nouveau`,
    REGISTRATION_STATUS_REQUIRED: `Statut de l’enregistrement requis`,
    REGISTRATION_SUCCESS: `Enregistrement réussi`,
    REGISTRATION_TYPE: `Type d’enregistrement`,
    REGISTRATION_TYPE_CANNOT_BE_NEW: `Le type d’enregistrement ne peut pas être Nouveau`,
    REGISTRATION_TYPE_REQUIRED: `Type d’enregistrement obligatoire`,
    REGISTRATION_UPDATED_SUCCESSFULLY: `Enregistrement mis à jour avec succès`,
    REGISTRATIONS_REVIEW: `Révision des enregistrements`,
    REIMBURSED: `Remboursé(e)`,
    REIMBURSED_AMOUNT: `Montant remboursé`,
    REIMBURSED_PERCENTAGE: `Pourcentage remboursé`,
    REIMBURSED_PERCENTAGE_INDICATOR: `Indicateur de pourcentage remboursé`,
    REIMBURSEMENT_DETAILS: `Détails de remboursement`,
    REIMBURSEMENT_PERCENTAGE: `Pourcentage de remboursement`,
    REIMBURSEMENT_SUMMARY: `Récapitulatif des remboursements`,
    REJECT: `Rejeter`,
    REJECT_LABOR_RATE: `Refuser le tarif de main d’œuvre`,
    REJECT_SPECIAL_ALLOWANCE_CLAIM: `Refuser la demande d’allocation commerciale`,
    REJECTED: `Rejeté(e)`,
    REJECTED_APPEAL: `Appel rejeté`,
    RELATIONSHIP: `Relation`,
    RELATIONSHIP_IS_REQUIRED: `Relation est obligatoire`,
    REMOVE_FILTER: `Supprimer le filtre`,
    REMOVE_FROM_AUDIT: `Supprimer de l’audit`,
    REMOVE_LAYOUT: `Supprimer la mise en page`,
    RENTAL_PINS: `NIP de location`,
    REPAIR_DATE: `Date de réparation`,
    REPAIR_DATE_CANNOT_BE_BEFORE_FAILURE_DATE: `La date de réparation ne peut pas être avant la date de panne`,
    REPAIR_NUMBER: `Numéro de réparation`,
    REPAIR_NUMBER_IS_REQUIRED: `Numéro de réparation est obligatoire`,
    REPAIR_REPLACE_INDICATOR: `Indicateur de réparation/remplacement`,
    REPAIRED: `Réparé(e)`,
    REPAIRED_DATE: `Date de réparation`,
    REPAIRED_DATE_CANNOT_BE_BEFORE_FAILED_DATE: `La date de réparation ne peut pas être avant  la date de panne`,
    REPAIRED_DATE_IS_REQUIRED: `Date de réparation est obligatoire`,
    REPORT_DATE: `Date du rapport`,
    REPORT_NUMBER: `Numéro du rapport`,
    REPORTS: `Rapports`,
    REQ_ADDL: `Modifier le crédit`,
    REQUEST: `Demande`,
    REQUEST_DATE: `Date de la requête`,
    REQUEST_DETAIL: `Détails de la demande`,
    REQUEST_DUPLICATE_PIN_PLATE: `Demander la copie de la plaque NIP`,
    REQUEST_FORM: `Formulaire de requête`,
    REQUEST_PIP_CODE: `Demander le code du programme (PIP)`,
    REQUEST_STATUS: `Statut de la demande`,
    REQUEST_SUBMITTED: `Requête soumise`,
    REQUEST_TYPE: `Type de demande`,
    REQUEST_UPDATED_SUCCESSFULLY: `Demande mise à jour avec succès`,
    REQUEST_WARRANTY_CLAIM_DEBIT: `Faire une requête de débit de la demande de garantie`,
    REQUESTED: `Reclamé(e)`,
    REQUESTED_BY: `Requête fait par`,
    REQUESTED_DATE: `Date de requête`,
    REQUESTED_DATES: `Dates de requête`,
    REQUESTED_DIAGNOSTIC_AMOUNT: `Montant de diagnostic souhaitée`,
    REQUESTED_DIAGNOSTIC_HOURS: `Heures de diagnostic souhaitées`,
    REQUESTED_LABOR_AMOUNT: `Montant de main-d’œuvre demandé`,
    REQUESTED_LABOR_HOURS: `Heures de main-d’œuvre demandées`,
    REQUESTED_OTHER_CREDITS: `Autres crédits demandés`,
    REQUESTED_PARTS: `Pièces demandées`,
    REQUESTED_REPAIR_AMOUNT: `Montant de réparation souhaitée`,
    REQUESTED_REPAIR_HOURS: `Heures de réparation souhaitées`,
    REQUESTED_TRAVEL_TOTAL: `Total de déplacement demandé`,
    REQUESTER_TCSM: `Demandeur (TCSM/MRSC)`,
    REQUESTER_TCSM_REQUIRED: `Demandeur (TCSM/MRSC) requis`,
    REQUIRED: `Obligatoire`,
    REQUIRED_CRITERIA: `Critères obligatoires`,
    REQUIRED_ITEMS: `Articles obligatoires`,
    RESEND_XML: `Réenvoyer XML`,
    RESET: `Réinitialiser`,
    RESPONDENT_INFORMATION: `Informations sur le repondant`,
    RESPONSIBILITY_OF: `Responsabilité de`,
    RESPONSIBLE_ACCOUNT: `Compte responsible`,
    RESPONSIBLE_ACCOUNT_IS_REQUIRED: `Compte responsable obligatoire`,
    RESPONSIBLE_DEALER: `Concessionnaire responsable`,
    RESPONSIBLE_DEALER_REPORT_RECORDS_COUNT_WARNING: `Affichage des 100 premiers résultats. Télécharger pour des résultats complets`,
    RET: `Retour`,
    RETAIL_INSTALL: `Vente au détail/installation`,
    RETAIL_INSTALL_DATE: `Date de vente au détail/installation`,
    RETAIL_INSTALL_IS_REQUIRED: `Vente au détail/installation est obligatoire`,
    RETAILER_NAME: `Nom de distributeur`,
    RETAILER_NAME_IS_REQUIRED: `Nom du distributeur est obligatoire`,
    RETRY: `Réessayer`,
    RETURN: `Retour`,
    RETURN_LABOR_RATE: `Taux de main-d'oeuvre de retour`,
    RETURN_REQUEST: `Demande de retour`,
    RETURN_SPECIAL_ALLOWANCE_CLAIM: `Retourner la demande de garantie d’allocation commerciale`,
    RETURN_STATUS: `Statut de de retour`,
    RETURNED: `Retourné(e)`,
    RETURNED_DATE_CANNOT_BE_BEFORE_DELIVERED_DATE: `La date de retour ne peut pas être avant la date de livraison`,
    RETURNED_DATE_IS_REQUIRED: `Date de retour est obligatoire`,
    RETURNED_MACHINE_STATUS_UPDATE: `Mise à jour de l'état de la machine retournée`,
    REVIEW_DEALER_RECOMMENDATIONS: `Voulez-vous vraiment marquer les NIP pour la révision ?`,
    REVISE: `Réviser`,
    REVISED: `Revisé(e)`,
    ROLLING_12_CREDIT_AMOUNT: `Étendu sur le montant de 12 crédits`,
    ROLLING_12_MONTHS: `Étendu sur  12 mois`,
    RUN_REPORT: `Générer un rapport`,
    RUSSIAN: `Russe`,
    SAP_DOWN_WARNING: `La fonctionnalité du système de garantie est endommagée. Nous travaillons à corriger cela le plus rapidement possible. Actualisez le navigateur pour vérifier la disponibilité du système.`,
    SAVE: `Sauvegarder`,
    SAVE_AS_DRAFT: `Sauvegarder comme brouillon`,
    SAVE_AS_NEW_LAYOUT: `Enregistrer la nouvelle mise en page`,
    SAVE_AUDIT: `Sauvegarder l’audit`,
    SAVE_CHANGES: `Sauvegarder les modifications`,
    SAVE_TO_VALIDATE: `Sauvegarder pour valider`,
    SAVE_VALD: `Sauvegarder et valider`,
    SAVE_VALIDATE: `Sauvegarder et valider`,
    SEARCH: `Rechercher`,
    SEARCH_BOX_PLACEHOLDER: `Saisir le NIP, numéro de série, numéro de demande de garantie, cas DTAC ou nom du client`,
    SEARCH_BY_CLAIM_TYPE: `Saisir le type complet de demande de garantie`,
    SEARCH_BY_CLAIM_TYPE_VALIDATION_FAIL: `La recherche de la demande de garantie doit inclure le type complet de demande de garantie, de 4 à 9 caractères`,
    SEARCH_BY_FAILURE_PART_NUMBER: `Saisir la référence complète de la pièce en panne`,
    SEARCH_BY_FAILURE_PART_NUMBER_VALIDATION_FAIL: `La recherche de demande de garantie doit inclure la reférence complète de la pièce en panne, 4 caractères au minimum`,
    SEARCH_BY_WORK_ORDER: `Sasir l'Ordre de Reparation, 2 caractères au minimum`,
    SEARCH_BY_WORK_ORDER_VALIDATION_FAIL: `La recherche de l'Ordre de Reparation doit être de 2 caractères au minimum.`,
    SEARCH_PRODUCT_BY_CLAIM_PLACEHOLDER: `Saisir le numéro complet de la demande de garantie`,
    SEARCH_PRODUCT_BY_CLAIM_VALIDATION_FAIL: `La recherche de demande de garantie doit se faire par le numéro complet de la demande, de 4 à 9 caractères`,
    SEARCH_PRODUCT_BY_COMPONENT_PLACEHOLDER: `Saisir le numéro de série complet du composant`,
    SEARCH_PRODUCT_BY_COMPONENT_VALIDATION_FAIL: `La recherche de composant doit se faire par le numéro de série complet, 1 caractère au minimum`,
    SEARCH_PRODUCT_BY_FULL_PIN_PLACEHOLDER: `Entrez le code confidentiel`,
    SEARCH_PRODUCT_BY_MODEL_PLACEHOLDER: `Saisir le numéro complet de modèle`,
    SEARCH_PRODUCT_BY_MODEL_VALIDATION_FAIL: `La recherche de modèle doit se faire par le numéro complet de modèle, de 3 à 12 caractères`,
    SEARCH_PRODUCT_BY_PIN_PLACEHOLDER: `Saisir le NIP, 6 caractères au minimum`,
    SEARCH_PRODUCT_BY_PIN_VALIDATION_FAIL: `La recherche du NIP doit être de 6 à 17 caractères`,
    SEARCH_PRODUCT_BY_PIP_PLACEHOLDER: `Saisir le numéro de programme (PIP, au moins 4 caractères)`,
    SEARCH_PRODUCT_BY_PIP_VALIDATION_FAIL: `La recherche du programme (PIP) doit être de 4 à 12 caractères`,
    SEARCH_RESULTS_TAB: `Résultats de la recherche ({count})`,
    SECOND_SHIP_TO_LOCATION: `Deuxième Envoi sur site`,
    SELECT: `Sélectionner`,
    SELECT_A_RANGE: `Sélectionner un intervalle`,
    SELECT_ALL: `Sélectionner tout`,
    SELECT_AUTO_SUBMIT: `Sélectionner la soumission automatique`,
    SELECT_BRANCH: `Sélectionner la succursale`,
    SELECT_CLAIM_TYPE: `Sélectionner le type de demande de garantie`,
    SELECT_CLAIMS: `Sélectionner les demandes de garantie`,
    SELECT_CLAIMS_WITHIN_DATE_RANGE: `Sélectionner les demandes de garantie dans l’intervalle de date`,
    SELECT_COLUMNS: `Sélectionner des colonnes`,
    SELECT_COUNTRY: `Identifier le pays`,
    SELECT_CSV_SEPARATOR: `Sélectionner CSV séparateur`,
    SELECT_DATE_FORMAT: `Sélectionner le format de date`,
    SELECT_DEALERS_AND_STATUS: `Sélectionner les concessionnaires et le statut`,
    SELECT_DECIMAL_FORMAT: `Sélectionner le format décimal`,
    SELECT_DISPLAY_FORMAT: `Sélectionner le format d’affichage`,
    SELECT_FACTORY: `Sélectionner les paramètres d’usine`,
    SELECT_LANGUAGE: `Sélectionner la langue`,
    SELECT_LAYOUT: `Sélectionner Mise en Page`,
    SELECT_NEW_CLAIMS: `Sélectionner des nouvelles demandes de garantie`,
    SELECT_PIP_CODE: `Sélectionner le code du programme (PIP)`,
    SELECT_PLAN_NAMES: `Sélectionner les noms des plans`,
    SELECT_SERVICE_INTERVAL_TYPES: `Sélectionner les types d’intervalles de service`,
    SELECT_SORT_BY: `Sélectionner Trier par`,
    SELECT_SORT_DIRECTION: `Sélectionner Direction de Tri`,
    SELECT_STATE: `Sélectionner la Region/Province`,
    SELECT_STATUS: `Sélectionner le statut`,
    SELECT_TERRITORY: `Sélectionner un territoire`,
    SELECT_THEME: `Sélectionner le thème`,
    SELECT_TIME_ZONE: `Sélectionner le fuseau horaire`,
    SELECT_VALUES_TO_APPROVE: `Sélectionner les valeurs à approuver`,
    SELECTED_COLUMNS: `Sélectionné Colonnes`,
    SELECTED_FOR_AUDIT: `Sélectionné pour l'audit`,
    SELECTED_FOR_AUDIT_VSR:  `Voir la solution DTAC 221475 pour la documentation d'audit requise et les pièces jointes nécessaires pour cette demande`,
    SELECTING_MULTIPLE_ACCOUNTS_AND_WARRANTY_TYPES_IMPACTS_PERFORMANCE: `La sélection de plusieurs comptes et de types de garantie a une influence sur la performance`,
    SEND: `Soumettre`,
    SERIAL_NUMBER: `Numéro de Série`,
    SERIAL_NUMBER_INVOICE_NUMBER: `Numéro de Série / Numéro de Facture`,
    SERVER_TOOK_TOO_LONG_TO_REPLY: `Le temps de réponse du serveur est trop long et la requête a été annulée. Veuillez essayer une requête plus spécifique ou réessayer plus tard ultérieurement.`,
    SERVICE_DATE_IS_REQUIRED: `Date de service est obligatoire`,
    SERVICE_INTERVAL: `Intervalle d'entretien`,
    SERVICE_INTERVAL_BEGIN_DATE: `Date de début d'intervalle d'entretien`,
    SERVICE_INTERVAL_END_DATE: `Date de fin d'intervalle d'entretien`,
    SERVICE_INTERVAL_IS_REQUIRED: `Intervalle d’entretien est obligatoire`,
    SERVICE_INTERVAL_NUMBER: `Numéro d'intervalle d'entretien`,
    SERVICE_INTERVAL_STATUS: `Statut d'intervalle d'entretien`,
    SERVICE_INTERVAL_TYPE: `Type d'intervalle d'entretien`,
    SERVICE_INTERVAL_TYPES: `Types d'intervalle d'entretien`,
    SERVICE_PART: `Pièce de service`,
    SERVICE_UNAVAILABLE: `Entretien non disponible`,
    SERVICED: `Entretenu(e)`,
    SERVICED_DATE_IS_REQUIRED: `Date de révision est requise.`,
    SERVICED_IS_REQUIRED: `Le service est requis.`,
    SET_AS_DEFAULT: `Enregistrer sous défaut`,
    SETTINGS: `Mes paramètres`,
    SETTLED: `Résolu(e)`,
    SETTLEMENT_NO_REGISTRATION: `Règlement, aucun enregistrement`,
    SETUP: `Configuration`,
    SETUP_DATE_IS_REQUIRED: `Date de configuration est obligatoire`,
    SETUP_IS_REQUIRED: `Configuration obligatoire`,
    SGST_UTGST: `SGST/UTGST`,
    SHIP_TO: `Envoyer à`,
    SHIPPED: `Expédié(e)`,
    SHIPPING_ID: `ID d'expédition`,
    SHIPPING_ID_REQUIRED: `ID d'expédition requis`,
    SHIPPING_INFORMATION_SPECIAL_INSTRUCTIONS: `Informations d'expédition/Instructions spéciales`,
    SHIPPING_INSTRUCTIONS: `Instructions d’expédition`,
    SHORT_TEXT: `Texte court`,
    SHORT_TEXT_IS_REQUIRED: `Un texte court est requis`,
    SHOW_ALL: `Montre tout ({count})`,
    SHOW_EXCLUDED: `Afficher les exclus`,
    SHOW_MORE: `Montre plus`,
    SHOW_MORE_GROUPS: `Afficher {countToDisplay} {count, plural, one {groupe supplémentaire} other {groupes supplémentaires}}`,
    SHOW_RED_IF_LESS_THAN: `Afficher Rouge si inférieur à`,
    SHOW_REIMBURSED_AMOUNT: `Afficher le montant remboursé`,
    SHOW_REIMBURSED_PERCENTAGE: `Afficher le pourcentage remboursé`,
    SHOW_YELLOW_IF_LESS_THAN: `Afficher Jaune si inférieur à`,
    SIGN_IN_REQUIRED: `Connexion requise`,
    SIGN_OUT: `Déconnexion`,
    SKIP_AUDIT: `Ignorer l'audit`,
    SKIP_AUDIT_SUCCESS: `L'audit a été ignoré et la date d'échéance est à venir.`,
    SOME_PARTS_RETURNED: `Certaines pièces Retournées`,
    SORT_BY: `Trier par`,
    SPANISH: `Espagnol`,
    SPECIAL_ALLOWANCE: `Allocation commerciale`,
    SPECIAL_ALLOWANCE_CALCULATION: `Calcul d’allocation commerciale`,
    SPECIAL_ALLOWANCE_CLAIM: `Demande de garantie d’allocation commerciale`,
    SPECIAL_ALLOWANCE_CLAIM_STATUS: `Statut de la demande de garantie d’allocation commerciale`,
    SPECIAL_ALLOWANCE_CLAIM_STATUS_TABM: `Statut de la demande de garantie d’allocation commerciale`,
    SPECIAL_ALLOWANCE_CLAIM_STATUS_UPDATED: `Statut de la demande de garantie d’allocation commerciale mis à jour`,
    SPECIAL_ALLOWANCE_CLAIM_WITH_ID: `Demande de garantie d’allocation commerciale - {claimNumber}`,
    SPECIAL_ALLOWANCE_CLAIMS_WITH_COUNT: `Demandes de garantie d’allocation commerciale ({count})`,
    SPECIAL_ALLOWANCE_CONTRIBUTIONS: `Contributions à l’allocation commerciale`,
    SPECIAL_ALLOWANCE_DESCRIPTION: `Description de l’allocation commerciale`,
    SPECIAL_ALLOWANCE_TYPE: `Type d'allocation Commerciale`,
    SPECIAL_ALLOWANCE_TYPE_IS_REQUIRED: `Type d’allocation commerciale est obligatoire`,
    SPECIAL_INSTRUCTIONS: `Instructions Spéciales`,
    SPG: `SPG`,
    SPGS: `SPG`,
    STANDARD_VIEW: `Vue générale`,
    START_AMOUNT_OF_USE: `Nombre d'usage au début`,
    STARTS: `Débute`,
    STARTS_WITH: `Débute par`,
    STATE: `Région/Province`,
    STATE_PROVINCE: `État/province`,
    STATE_PROVINCE_REQUIRED: `État/province requis`,
    STATUS: `Statut`,
    STATUS_CHANGE_REQUEST: `Requête de changement de statut`,
    STATUS_CHANGE_REQUEST_CREATED_SUCCESSFULLY: `Requête de modification de statut créée avec succès`,
    STATUS_CHANGE_REQUEST_UPDATED_SUCCESSFULLY: `Demande d'état de la machine mise à jour réussie`,
    STATUS_FOR: `Statut pour {pin}`,
    STATUS_INDICATOR: `Indicateur de statut`,
    STATUS_REASON: `Raison de l'état`,
    STOLEN_DATE: `Date de vol`,
    STORE: `Entrpôt`,
    STORE_IS_REQUIRED: `Entrpôt est obligatoire`,
    STORE_NUMBER_IS_REQUIRED: `Numéro de magasin est obligatoire`,
    STREET_1: `Rue 1`,
    STREET_2: `Rue 2`,
    SUB: `Soumettre`,
    SUB_CLAIM_TYPE: `Demande de garantie subsidiaire`,
    SUB_TYPE: `Sous-type`,
    SUBMISSION_DATE: `Date de soumission`,
    SUBMIT: `Soumettre`,
    SUBMIT_AUDIT: `Soumettre l’audit`,
    SUBMIT_AUDIT_FOR: `Soumettre l’audit pour {dealer}`,
    SUBMIT_FULL_DEBIT_CLAIM_FOR_WITH_CLAIM_NUMBER: `Soumettre une demande de débit total pour {claimNumber}`,
    SUBMIT_PARTIAL_DEBIT_CLAIM_FOR_WITH_CLAIM_NUMBER: `Soumettre une demande de débit partiel pour {claimNumber}`,
    SUBMIT_PERCENTAGE_DEBIT_CLAIM_FOR_WITH_CLAIM_NUMBER: `Soumettre une demande de débit en pourcentage pour {claimNumber}`,
    SUBMIT_REQUEST: `Soumettre la requête`,
    SUBMITTED: `Soumis(e)`,
    SUBMITTED_AVAILABLE_TO_EDIT: `Soumis(e) (Modifiable)`,
    SUCCESS: `Succès`,
    SUCCESS_MESSAGE_TITLE: `Une opération a réussi:`,
    SUCCESS_MESSAGES_TITLE: `Plusieurs opérations ont réussi:`,
    SUPPLIER_WARRANTY: `Garantie du fournisseur`,
    SURVEY_QUESTIONS: `Questions de sondage`,
    SUSPENDED: `Suspendu(e)`,
    SWEDISH: `Suédois`,
    SYSTEM_SELECTED_CLAIMS: `Demandes sélectionnées par le système`,
    SYSTEM_SELECTED_CLAIMS_WITH_COUNT: `Demandes sélectionnées par le système ({count})`,
    TABM: `TABM`,
    TAX: `Taxe`,
    TCSM: `TCSM/MRSC`,
    TCSM_COMMENTS: `Commentaires du TCSM/MRSC`,
    TCSM_ID: `ID du TCSM/MRSC`,
    TECH_ID: `Identifiant du technicien`,
    TERMINATED: `Terminé(e)`,
    TERMINATES: `Termine`,
    TERRITORY: `Territoire`,
    TEST: `Test`,
    TEST_RESULTS_CODE: `Code des résultats des test`,
    THEME: `Thème`,
    TIME_LIMIT: `Limite de temps`,
    TIME_ZONE: `Fuseau horaire`,
    TITLE: `Titre`,
    TITLE_IS_REQUIRED: `Le titre est obligatoire`,
    TO: `à`,
    TODAY: `Aujourd’hui`,
    TOO_MANY_RESULTS: `Votre demande a donné trop de résultats. Veuillez affiner vos termes de recherche et réessayer.`,
    TOTAL: `Total`,
    TOTAL_AMOUNT: `Montant total`,
    TOTAL_AMOUNT_IN_LOCAL_CURRENCY: `Total en PLN`,
    TOTAL_APPROVED: `Total approuvé`,
    TOTAL_APPROVED_CLAIM_VALUE: `Valeur totale de la demande de garantie approuvée`,
    TOTAL_APPROVED_INCLUDING_TAXES: `Total approuvé TTC`,
    TOTAL_APPROVED_WITHOUT_ADDITIVES: `Total approuvé sans additifs`,
    TOTAL_CONTRIBUTION: `Contribution totale`,
    TOTAL_REIMBURSED: `Total remboursé`,
    TOTAL_REIMBURSED_WITH_CURRENCY: `Total remboursé ({currency})`,
    TOTAL_REQUESTED: `Total reclamé`,
    TOTAL_REQUESTED_CLAIM_VALUE: `Valeur totale de la demande de garantie reclamée`,
    TOTAL_UNPAID: `Total non payé`,
    TRACKING_NUMBER: `Numéro de suivi`,
    TRANSFER: `Transférer`,
    TRANSFER_ALL: `Tout transférer`,
    TRANSFER_APPROVALS: `Approbations de transfert`,
    TRANSFER_APPROVALS_TAB: `Approbations de transfert ({count})`,
    TRANSFER_CREATED: `Transfert créé`,
    TRANSFER_DEALER_RECOMMENDATIONS: `Transférer les recommandations du concessionnaire`,
    TRANSFER_REJECTED: `Transfert rejeté`,
    TRANSFER_UPDATED_SUCCESSFULLY: `Transfert mis à jour avec succès`,
    TRANSFERALL_DEALER_RECOMMENDATIONS: `Transférer toutes les recommandations du concessionnaire`,
    TRANSFERS: `Transferts`,
    TRAVEL: `Frais de déplacement`,
    TURKISH: `Turc`,
    TWO_PERCENT_WITHHOLD_VALUE: `2% de retenue`,
    TYPE: `Type`,
    TYPES: `Types`,
    UNABLE_TO_CONTACT_THE_SERVER: `Impossible de contacter le serveur`,
    UNABLE_TO_COPY_ATTACHMENTS: `Nous n'avons pas pu copier les pièces jointes de la demande d'origine, veuillez les consulter avant de soumettre votre nouvelle demande.`,
    UNABLE_TO_LOAD_CUSTOMER_DETAILS: `Impossible de charger les données du client`,
    UNDO: `Annuler`,
    UNDO_REGISTRATION: `Annuler l'enregistrement`,
    UNDO_REGISTRATION_SUCCESSFULL: `Annuler l'enregistrement réussi`,
    UNIT: `Unité`,
    UNIT_1: `Unité 1`,
    UNIT_2: `Unité 2`,
    UNIT_3: `Unité 3`,
    UNIT_OF_MEASURE: `Unité de mesure`,
    UNPAID_LABOR: `Main d'oeuvre non payée`,
    UNPAID_LABOR_ADDITIVES_EXCLUDING_PIPS: `Additifs de main-d’œuvre  non rémunérés - à l'exclusion des programmes d’amélioration (PIP)`,
    UNPAID_LABOR_ADDITIVES_PIPS: `Additifs de main-d’œuvre  non rémunérés – programmes d’amélioration (PIP)`,
    UNPAID_OTHER_CREDITS: `Autres Crédits non rémunérés`,
    UNPAID_PARTS: `Pièces non rémunérés`,
    UNPAID_PARTS_ADDITIVE: `Additif des pièces non rémunérés`,
    UNPAID_TRAVEL: `Déplacement non rémunéré`,
    UNRECONCIL: `Non concilié`,
    UNRECONCILE_CLAIM : `Demande de non-rapprochement`,
    UNSUB: `Modifier`,
    UNSUBMIT_CLAIM: `Modifier Demande`,
    UPDATE: `Mise à jour`,
    UPDATE_CUSTOMER_INFORMATION: `Mettre à jour l'information du client`,
    UPDATE_LABOR_RATES: `Mise à jour des taux de main-d’œuvre`,
    UPDATE_LAYOUT: `Mettre à jour la disposition`,
    UPDATE_MACHINE_STATUS: `Actualiser le statut de la machine`,
    UPDATE_MACHINE_STATUS_HISTORY: `Actualiser l’historique du statut de la machine`,
    UPDATE_REGISTRATION: `Mettre à jour l'enregistrement`,
    UPDATE_SELECTED: `Mettre à jour la sélection`,
    UPDATED: `Mis à jour`,
    UPDATED_BY: `Mis à jour par`,
    UPDATED_DATE_FROM: `Date de mise à jour de`,
    UPDATED_DATE_TO: `Date de mise à jour à`,
    UPLOAD_DOCUMENT: `Télécharger le document`,
    UPTIME_ASSURANCE: `Assurance de disponibilité`,
    USEFUL_LINKS: `Liens utiles`,
    USER: `utilisateur`,
    USER_PREFERENCES_UPDATED: `Mise à jour des préférences de l’utilisateur`,
    USER_SELECTED: `Utilisateur sélectionné`,
    USER_SELECTED_CLAIMS_WITH_COUNT: `Demandes de garantie sélectionnées par l’utilisateur ({count})`,
    USERS_INFORMATION: `Informations sur les utilisateurs`,
    VALIDATE: `Valider`,
    VALIDATE_CLAIM: `Valider la demande de garantie`,
    VALUE: `Valeur`,
    VALUE_OF_REPAIR: `Valeur de la réparation`,
    VIEW_CLAIM: `Afficher la demande de garantie`,
    VIEW_DETAILS: `Afficher les détails`,
    VIEW_OPEN_PIPS: `Afficher les Programmes (PIP) ouverts`,
    VIEW_PIP: `Afficher le Programme (PIP)`,
    VIEW_PRODUCTS: `Afficher les produits`,
    VIEW_PRODUCTS_AND_UPDATE_INFO: `Afficher les produits et les informations de mise à jour`,
    VIEW_UPDATE: `Afficher/mettre à jour`,
    VSR_MESSAGES: `Messages VSR`,
    WAITING_FOR_DLR_INV: `En attente de la facture du concessionnaire`,
    WAITING_FOR_INVOICE: `En attente de la facture ({count})`,
    WAITING_SINCE: `En attente depuis`,
    WARNING_MESSAGE_TITLE: `Un avertissement a été envoyé:`,
    WARNING_MESSAGES: `Messages d’avertissement`,
    WARNING_MESSAGES_TITLE: `Plusieurs avertissements ont été envoyés:`,
    WARRANTY: `Garantie`,
    WARRANTY_ADMIN: `Garantie Administrateur`,
    WARRANTY_CLAIM_TYPE: `Type de demande à titre de garantie`,
    WARRANTY_COVERAGE: `Couverture de la garantie`,
    WARRANTY_EXPIRATION: `Expiration de la garantie`,
    WARRANTY_TYPE: `Type de garantie`,
    WARRANTY_TYPES: `Types de garanties`,
    WEAR_PARTS: `Porter des pièces`,
    WEAR_PARTS_COVERAGE: `Couverture des pièces de rechange`,
    WELCOME: `Bienvenue`,
    WINTERIZATION: `Hivernage`,
    WIP: `Travail en cours`,
    WITH_ADDITIVES: `Avec additifs`,
    WITNESS_FIRST_NAME: `Prénom du témoin`,
    WITNESS_LAST_NAME: `Nom de famille du témoin`,
    WORK_ORDER: `Ordre de réparation`,
    WORK_ORDER_NUMBER: `Numéro d'Ordre de réparation`,
    WORK_ORDER_ONE: `Ordre de réparation 1`,
    WORK_ORDER_ONE_IS_REQUIRED: `L'ordre de réparation est obligatoire`,
    WORK_ORDER_THREE: `Ordre de réparation 3`,
    WORK_ORDER_THREE_IS_REQUIRED: `L'ordre de réparation 3 est obligatoire`,
    WORK_ORDER_TWO: `Ordre de réparation 2`,
    WORK_REPAIR_ORDER: `Ordre de réparation`,
    YES: `Oui`,
    YES_LOWERCASE: `Oui`
});



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-i18n/lib/fr.js